var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 431,
    viewBox: "0 0 1366 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.212 353.731L120.534 353.832L119.852 342.113L130.212 353.731Z",
    fill: "#E9FE53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.154 281.077L185.476 281.178L184.795 269.459L195.154 281.077Z",
    fill: "#E9FE53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.227 357.805L223.454 352.039L229.991 342.289L231.227 357.805Z",
    fill: "#E9FE53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.223 285.22L143.603 292.28L134.667 284.667L150.223 285.22Z",
    fill: "#E9FE53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M283.988 253.721L278.654 245.645L288.131 238.717L283.988 253.721Z",
    fill: "#E9FE53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M279.147 320.199L273.813 312.123L283.289 305.195L279.147 320.199Z",
    fill: "#E9FE53"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.388 223.308L205.712 223.091L205.416 211.356L215.388 223.308Z",
    fill: "#E9FE53"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.265 256.177L114.589 255.961L114.293 244.225L124.265 256.177Z",
    fill: "#E9FE53"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.157 359.7L179.826 357.128L182.404 345.676L189.157 359.7Z",
    fill: "#E9FE53"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M296.132 151.509L286.455 151.611L285.773 139.891L296.132 151.509Z",
    fill: "#E9FE53"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M361.075 78.8551L351.397 78.9567L350.716 67.2375L361.075 78.8551Z",
    fill: "#E9FE53"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M397.148 155.583L389.375 149.817L395.912 140.067L397.148 155.583Z",
    fill: "#E9FE53"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M316.144 82.9981L309.524 90.0583L300.588 82.4453L316.144 82.9981Z",
    fill: "#E9FE53"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M449.909 51.4996L444.575 43.4238L454.052 36.4955L449.909 51.4996Z",
    fill: "#E9FE53"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M445.068 117.977L439.733 109.901L449.21 102.973L445.068 117.977Z",
    fill: "#E9FE53"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M381.309 41.0862L371.633 40.8696L371.337 29.1343L381.309 41.0862Z",
    fill: "#E9FE53"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M290.186 53.9554L280.51 53.7389L280.214 42.0036L290.186 53.9554Z",
    fill: "#E9FE53"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M355.078 157.479L345.747 154.906L348.325 143.454L355.078 157.479Z",
    fill: "#E9FE53"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M110.302 70.3374L112.848 61L124.308 63.5466L110.302 70.3374Z",
    fill: "#E9FE53"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M162.447 152.66L164.994 143.322L176.453 145.869L162.447 152.66Z",
    fill: "#E9FE53"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7825 166.396L86.4531 160.494L94.0461 169.446L78.7825 166.396Z",
    fill: "#E9FE53"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M170.739 108.306L165.756 100.009L175.521 93.4936L170.739 108.306Z",
    fill: "#E9FE53"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M164.49 245.588L173.716 242.664L177.791 253.673L164.49 245.588Z",
    fill: "#E9FE53"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M101.864 222.767L111.09 219.843L115.166 230.852L101.864 222.767Z",
    fill: "#E9FE53"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M212.49 187.908L215.342 178.66L226.712 181.582L212.49 187.908Z",
    fill: "#E9FE53"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M205.768 91.2718L208.62 82.0232L219.99 84.945L205.768 91.2718Z",
    fill: "#E9FE53"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4543 125.409L93.478 117.136L103.79 122.745L88.4543 125.409Z",
    fill: "#E9FE53"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M256.634 386.603L254.79 377.102L266.195 374.32L256.634 386.603Z",
    fill: "#E9FE53"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M351.519 363.174L349.988 353.618L361.478 351.212L351.519 363.174Z",
    fill: "#E9FE53"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.43741 435.102L-11.7507 427.766L-3.22734 419.694L-5.43741 435.102Z",
    fill: "#E9FE53"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3368 367.7L59.2681 360.16L68.0522 352.373L65.3368 367.7Z",
    fill: "#E9FE53"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.14 204.76L1237.82 204.659L1238.5 216.378L1228.14 204.76Z",
    fill: "#E9FE53"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.07 128.032L1199.84 133.798L1193.3 143.548L1192.07 128.032Z",
    fill: "#E9FE53"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.31 232.116L1144.64 240.191L1135.17 247.12L1139.31 232.116Z",
    fill: "#E9FE53"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.15 165.638L1149.48 173.714L1140.01 180.642L1144.15 165.638Z",
    fill: "#E9FE53"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.91 262.529L1217.58 262.746L1217.88 274.481L1207.91 262.529Z",
    fill: "#E9FE53"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.14 126.136L1243.47 128.709L1240.89 140.161L1234.14 126.136Z",
    fill: "#E9FE53"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.17 323.792L1124.85 323.691L1125.53 335.41L1115.17 323.792Z",
    fill: "#E9FE53"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.07 377.075L1099.74 376.974L1100.43 388.693L1090.07 377.075Z",
    fill: "#E9FE53"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M966.233 357.324L971.567 365.4L962.091 372.329L966.233 357.324Z",
    fill: "#E9FE53"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.22 317.823L1065.55 320.395L1062.98 331.847L1056.22 317.823Z",
    fill: "#E9FE53"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.55 346.311L1260.01 355.648L1248.55 353.102L1262.55 346.311Z",
    fill: "#E9FE53"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.22 332.575L1338.55 338.477L1330.96 329.524L1346.22 332.575Z",
    fill: "#E9FE53"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.14 276.204L1313.91 279.128L1309.84 268.119L1323.14 276.204Z",
    fill: "#E9FE53"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.51 311.062L1209.66 320.311L1198.29 317.389L1212.51 311.062Z",
    fill: "#E9FE53"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1336.55 373.562L1331.52 381.835L1321.21 376.225L1336.55 373.562Z",
    fill: "#E9FE53"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.91 92.1778L1162.63 100.863L1151.87 96.1894L1166.91 92.1778Z",
    fill: "#E9FE53"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.02 59.0364L1048.04 65.7384L1039.51 57.6656L1055.02 59.0364Z",
    fill: "#E9FE53"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.28 51.8186L1114.3 58.5206L1105.78 50.4478L1121.28 51.8186Z",
    fill: "#E9FE53"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.46 131.994L1038.99 141.55L1027.5 143.956L1037.46 131.994Z",
    fill: "#E9FE53"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.22 215.702L1087.75 225.258L1076.26 227.664L1086.22 215.702Z",
    fill: "#E9FE53"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.22 144.804L1352.53 152.14L1344.01 160.212L1346.22 144.804Z",
    fill: "#E9FE53"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.06 94.4928L1265.32 103.775L1253.91 100.992L1268.06 94.4928Z",
    fill: "#E9FE53"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1322.02 55.3629L1319.28 64.6455L1307.87 61.8623L1322.02 55.3629Z",
    fill: "#E9FE53"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1289 166.551L1295.07 174.091L1286.28 181.878L1289 166.551Z",
    fill: "#E9FE53"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.85 215.06L1378.92 222.6L1370.13 230.387L1372.85 215.06Z",
    fill: "#E9FE53"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_659_491)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M973.611 374.508C974.775 374.221 977.111 373.194 977.144 371.386C977.185 369.127 971.473 367.854 969.954 369.949C968.435 372.044 970.078 374.056 973.611 374.508ZM970.867 369.977C970.447 370.538 970.087 371.645 972.004 371.579C974.399 371.497 973.003 368.827 970.867 369.977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.867 369.977C970.447 370.538 970.087 371.645 972.004 371.579C974.399 371.497 973.003 368.827 970.867 369.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1014.53 328.09C1014.53 328.09 1007.49 335.157 1003.74 340.401C998.771 339.483 992.393 339.122 986.53 340.692C983.483 337.395 972.578 331.736 972.578 331.736C972.578 331.736 971.698 342.683 973.665 347.69C969.899 351.34 967.155 356.357 966.295 363.054C966.141 364.255 966.047 365.511 966.019 366.821C964.18 372.031 963.273 383.168 972.078 390.452C969.188 391.966 960.208 370.13 955.541 374.508C949.707 379.981 940.521 377.804 957.164 391.328C966.807 395.544 976.417 407.038 976.529 408.037C971.951 449.136 1018.19 493.798 1030.88 493.656C1036.77 493.59 1044.22 489.401 1050.23 481.455C1051.68 481.745 1053.68 481.951 1055.86 482.174C1061.96 482.801 1069.43 483.569 1069.93 486.72C1070.67 491.382 1066.43 491.754 1061.93 492.149C1057.14 492.57 1052.06 493.017 1052.36 498.692C1052.94 509.698 1079.39 506.802 1083.25 490.389C1086.34 477.259 1066.71 471.504 1056.51 470.268C1060.42 460.588 1062.24 448.041 1059.83 432.886C1054.88 401.761 1037.36 382.118 1029.22 376.186C1031.03 360.624 1024.85 351.914 1021.54 349.504C1021.29 340.935 1014.53 328.09 1014.53 328.09ZM977.144 371.386C977.111 373.194 974.775 374.221 973.611 374.508C970.078 374.056 968.435 372.044 969.954 369.949C971.473 367.854 977.185 369.127 977.144 371.386ZM969.954 383.16C971.139 382.734 972.75 381.209 973.743 380.094C975.005 382.132 976.949 384.529 978.953 385.625C978.651 386.397 978.341 387.04 978.025 387.566C976.624 390.259 973.417 389.322 971.659 386.558C970.968 385.47 970.38 384.243 969.954 383.16Z",
    fill: "url(#paint0_linear_659_491)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M969.954 383.16C971.139 382.734 972.75 381.209 973.743 380.094C975.005 382.132 976.949 384.529 978.953 385.625C978.651 386.397 978.341 387.04 978.025 387.566C976.243 385.257 973.039 385.932 971.659 386.558C970.968 385.47 970.38 384.243 969.954 383.16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.659 386.558C973.417 389.322 976.624 390.259 978.025 387.566C976.243 385.257 973.039 385.932 971.659 386.558Z",
    fill: "#ED1B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.42 392.906C1000.46 395.775 989.263 399.792 976.117 392.906C974.555 392.088 973.265 391.435 972.078 390.452M1017.33 387.298C1019.07 386.385 1023.01 383.777 1024.89 380.647M1001.68 343.48C1003.63 338.698 1014.53 328.09 1014.53 328.09M1014.53 328.09C1014.53 328.09 1021.29 340.935 1021.54 349.504M1014.53 328.09C1014.53 328.09 1007.49 335.157 1003.74 340.401C998.771 339.483 992.393 339.122 986.53 340.692M1021.5 351.173C1021.5 350.57 1021.56 350.183 1021.54 349.504M986.53 340.692C983.483 337.395 972.578 331.736 972.578 331.736C972.578 331.736 971.698 342.683 973.665 347.69M986.53 340.692C983.545 341.491 980.557 342.422 977.907 344.072M973.665 347.69C974.99 346.406 976.367 345.032 977.907 344.072M973.665 347.69C969.899 351.34 967.155 356.357 966.295 363.054M974.802 338.084L977.907 344.072M1012.58 335.283C1011.58 336.001 1006.62 341.864 1008.49 342.968C1009.98 343.852 1013.47 345.587 1015.02 346.344M1021.54 349.504C1024.85 351.914 1031.03 360.624 1029.22 376.186C1037.36 382.118 1054.88 401.761 1059.83 432.886C1062.24 448.041 1060.42 460.588 1056.51 470.268M977.907 400.205C977.216 402.708 976.812 405.495 976.529 408.037M972.078 390.452C963.273 383.168 964.18 372.031 966.019 366.821C966.047 365.511 966.141 364.255 966.295 363.054M972.078 390.452C969.188 391.966 960.208 370.13 955.541 374.508C949.707 379.981 940.521 377.804 957.164 391.328C966.807 395.544 976.417 407.038 976.529 408.037M976.529 408.037C971.951 449.136 1018.19 493.798 1030.88 493.656C1036.77 493.59 1044.22 489.401 1050.23 481.455M1056.51 470.268C1066.71 471.504 1086.34 477.259 1083.25 490.389C1079.39 506.802 1052.94 509.698 1052.36 498.692C1052.06 493.017 1057.14 492.57 1061.93 492.149C1066.43 491.754 1070.67 491.382 1069.93 486.72C1069.43 483.569 1061.96 482.801 1055.86 482.174C1053.68 481.951 1051.68 481.745 1050.23 481.455M1056.51 470.268C1054.77 474.571 1052.61 478.308 1050.23 481.455M966.295 363.054C967.084 363.329 968.845 364.086 969.88 365.949M986.456 365.949C987.031 364.105 995.894 360.964 1000.21 367.474M973.611 374.508L973.743 380.094M973.611 374.508C974.775 374.221 977.111 373.194 977.144 371.386C977.185 369.127 971.473 367.854 969.954 369.949C968.435 372.044 970.078 374.056 973.611 374.508ZM973.743 380.094C972.75 381.209 971.139 382.734 969.954 383.16M973.743 380.094C975.005 382.132 976.949 384.529 978.953 385.625M985.529 379.835C984.069 386.052 981.5 387.019 978.953 385.625M969.88 377.733C969.277 377.908 968.135 378.974 968.387 381.834C968.488 382.979 969.163 383.444 969.954 383.16M969.954 383.16C970.38 384.243 970.968 385.47 971.659 386.558M978.953 385.625C978.651 386.397 978.341 387.04 978.025 387.566M971.659 386.558C973.417 389.322 976.624 390.259 978.025 387.566M971.659 386.558C973.039 385.932 976.243 385.257 978.025 387.566M970.867 369.977C970.447 370.538 970.087 371.645 972.004 371.579C974.399 371.497 973.003 368.827 970.867 369.977Z",
    stroke: "black",
    strokeWidth: 1.12159
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.45 421.206L1013.45 420.978L1013.2 420.978L1013.21 421.207L1013.45 421.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.55 421.212L1011.55 420.983L1011.31 420.984L1011.31 421.212L1011.55 421.212Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.65 421.217L1009.65 420.989L1009.41 420.99L1009.41 421.218L1009.65 421.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.76 421.223L1007.76 420.994L1007.51 420.995L1007.51 421.224L1007.76 421.223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.86 421.228L1005.86 421L1005.62 421.001L1005.62 421.229L1005.86 421.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.96 421.234L1003.96 421.006L1003.72 421.006L1003.72 421.235L1003.96 421.234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.06 421.24L1002.06 421.011L1001.82 421.012L1001.82 421.24L1002.06 421.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.17 421.245L1000.17 421.017L999.924 421.018L999.924 421.246L1000.17 421.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.27 421.251L998.269 421.022L998.026 421.023L998.027 421.252L998.27 421.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.372 421.256L996.372 421.028L996.129 421.029L996.13 421.257L996.372 421.256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.475 421.262L994.474 421.034L994.232 421.034L994.232 421.263L994.475 421.262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.578 421.268L992.577 421.039L992.334 421.04L992.335 421.268L992.578 421.268Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.681 421.273L990.68 421.045L990.437 421.046L990.438 421.274L990.681 421.273Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.783 421.279L988.783 421.05L988.54 421.051L988.541 421.28L988.783 421.279Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.886 421.285L986.885 421.056L986.643 421.057L986.643 421.285L986.886 421.285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.989 421.29L984.988 421.062L984.745 421.062L984.746 421.291L984.989 421.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.091 421.296L983.091 421.067L982.848 421.068L982.849 421.296L983.091 421.296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.194 421.301L981.194 421.073L980.951 421.074L980.952 421.302L981.194 421.301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.297 421.307L979.296 421.078L979.054 421.079L979.054 421.308L979.297 421.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.43 423.017L1014.43 422.734L1014.13 422.734L1014.13 423.017L1014.43 423.017Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.53 423.022L1012.53 422.739L1012.23 422.74L1012.23 423.023L1012.53 423.022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.64 423.028L1010.64 422.745L1010.33 422.746L1010.34 423.029L1010.64 423.028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.74 423.033L1008.74 422.75L1008.44 422.751L1008.44 423.034L1008.74 423.033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.84 423.039L1006.84 422.756L1006.54 422.757L1006.54 423.04L1006.84 423.039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.94 423.045L1004.94 422.762L1004.64 422.762L1004.64 423.045L1004.94 423.045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.05 423.05L1003.05 422.767L1002.75 422.768L1002.75 423.051L1003.05 423.05Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.15 423.056L1001.15 422.773L1000.85 422.774L1000.85 423.057L1001.15 423.056Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.253 423.061L999.252 422.778L998.951 422.779L998.952 423.062L999.253 423.061Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.355 423.067L997.354 422.784L997.054 422.785L997.055 423.068L997.355 423.067Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.458 423.073L995.457 422.79L995.157 422.79L995.157 423.073L995.458 423.073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.561 423.078L993.56 422.795L993.259 422.796L993.26 423.079L993.561 423.078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.663 423.084L991.663 422.801L991.362 422.802L991.363 423.085L991.663 423.084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.766 423.089L989.765 422.806L989.465 422.807L989.466 423.09L989.766 423.089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.869 423.095L987.868 422.812L987.567 422.813L987.568 423.096L987.869 423.095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.972 423.101L985.971 422.818L985.67 422.818L985.671 423.101L985.972 423.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.074 423.106L984.074 422.823L983.773 422.824L983.774 423.107L984.074 423.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.177 423.112L982.176 422.829L981.876 422.83L981.877 423.113L982.177 423.112Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.28 423.117L980.279 422.834L979.978 422.835L979.979 423.118L980.28 423.117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.42 424.829L1015.41 424.488L1015.05 424.489L1015.05 424.83L1015.42 424.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.52 424.834L1013.52 424.493L1013.15 424.494L1013.16 424.835L1013.52 424.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.62 424.84L1011.62 424.499L1011.26 424.5L1011.26 424.841L1011.62 424.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.72 424.846L1009.72 424.505L1009.36 424.506L1009.36 424.847L1009.72 424.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.83 424.851L1007.83 424.51L1007.46 424.511L1007.46 424.852L1007.83 424.851Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.93 424.857L1005.93 424.516L1005.57 424.517L1005.57 424.858L1005.93 424.857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.03 424.862L1004.03 424.521L1003.67 424.522L1003.67 424.863L1004.03 424.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.13 424.868L1002.13 424.527L1001.77 424.528L1001.77 424.869L1002.13 424.868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.24 424.874L1000.24 424.533L999.874 424.534L999.875 424.875L1000.24 424.874Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.34 424.879L998.339 424.538L997.977 424.539L997.978 424.88L998.34 424.879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.443 424.885L996.442 424.544L996.08 424.545L996.081 424.886L996.443 424.885Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.546 424.89L994.545 424.549L994.182 424.55L994.183 424.891L994.546 424.89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.648 424.896L992.647 424.555L992.285 424.556L992.286 424.897L992.648 424.896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.751 424.902L990.75 424.561L990.388 424.562L990.389 424.903L990.751 424.902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.854 424.907L988.853 424.566L988.491 424.567L988.492 424.908L988.854 424.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.956 424.913L986.955 424.572L986.593 424.573L986.594 424.914L986.956 424.913Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.059 424.918L985.058 424.577L984.696 424.578L984.697 424.919L985.059 424.918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.162 424.924L983.161 424.583L982.799 424.584L982.8 424.925L983.162 424.924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.265 424.93L981.264 424.589L980.901 424.59L980.902 424.931L981.265 424.93Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.367 424.935L979.366 424.594L979.004 424.595L979.005 424.936L979.367 424.935Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.4 426.641L1016.4 426.242L1015.98 426.243L1015.98 426.642L1016.4 426.641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.5 426.647L1014.5 426.248L1014.08 426.249L1014.08 426.648L1014.5 426.647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.61 426.652L1012.6 426.253L1012.18 426.254L1012.18 426.653L1012.61 426.652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.71 426.658L1010.71 426.259L1010.28 426.26L1010.28 426.659L1010.71 426.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.81 426.663L1008.81 426.264L1008.39 426.266L1008.39 426.665L1008.81 426.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.91 426.669L1006.91 426.27L1006.49 426.271L1006.49 426.67L1006.91 426.669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.02 426.675L1005.02 426.276L1004.59 426.277L1004.59 426.676L1005.02 426.675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.12 426.68L1003.12 426.281L1002.69 426.282L1002.7 426.681L1003.12 426.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.22 426.686L1001.22 426.287L1000.8 426.288L1000.8 426.687L1001.22 426.686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.325 426.691L999.324 426.292L998.9 426.294L998.901 426.693L999.325 426.691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.428 426.697L997.426 426.298L997.003 426.299L997.004 426.698L997.428 426.697Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.53 426.703L995.529 426.304L995.105 426.305L995.107 426.704L995.53 426.703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.633 426.708L993.632 426.309L993.208 426.31L993.209 426.709L993.633 426.708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.736 426.714L991.735 426.315L991.311 426.316L991.312 426.715L991.736 426.714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.839 426.719L989.837 426.32L989.414 426.322L989.415 426.721L989.839 426.719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.941 426.725L987.94 426.326L987.516 426.327L987.517 426.726L987.941 426.725Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.044 426.731L986.043 426.332L985.619 426.333L985.62 426.732L986.044 426.731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.147 426.736L984.146 426.337L983.722 426.338L983.723 426.737L984.147 426.736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.249 426.742L982.248 426.343L981.824 426.344L981.826 426.743L982.249 426.742Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.352 426.747L980.351 426.348L979.927 426.35L979.928 426.749L980.352 426.747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.38 428.451L1017.38 427.998L1016.9 427.999L1016.9 428.453L1017.38 428.451Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.49 428.457L1015.48 428.003L1015 428.005L1015 428.458L1015.49 428.457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.59 428.463L1013.59 428.009L1013.11 428.011L1013.11 428.464L1013.59 428.463Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.69 428.468L1011.69 428.015L1011.21 428.016L1011.21 428.47L1011.69 428.468Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.79 428.474L1009.79 428.02L1009.31 428.022L1009.31 428.475L1009.79 428.474Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.9 428.479L1007.9 428.026L1007.41 428.027L1007.42 428.481L1007.9 428.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006 428.485L1006 428.031L1005.52 428.033L1005.52 428.486L1006 428.485Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.1 428.491L1004.1 428.037L1003.62 428.039L1003.62 428.492L1004.1 428.491Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.21 428.496L1002.2 428.043L1001.72 428.044L1001.72 428.498L1002.21 428.496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.31 428.502L1000.31 428.048L999.825 428.05L999.826 428.503L1000.31 428.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.411 428.507L998.409 428.054L997.927 428.055L997.929 428.509L998.411 428.507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.513 428.513L996.512 428.06L996.03 428.061L996.032 428.514L996.513 428.513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.616 428.519L994.615 428.065L994.133 428.067L994.134 428.52L994.616 428.519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.719 428.524L992.717 428.071L992.236 428.072L992.237 428.526L992.719 428.524Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.821 428.53L990.82 428.076L990.338 428.078L990.34 428.531L990.821 428.53Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.924 428.535L988.923 428.082L988.441 428.083L988.442 428.537L988.924 428.535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.027 428.541L987.026 428.088L986.544 428.089L986.545 428.542L987.027 428.541Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.13 428.547L985.128 428.093L984.647 428.095L984.648 428.548L985.13 428.547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.232 428.552L983.231 428.099L982.749 428.1L982.751 428.554L983.232 428.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.335 428.558L981.334 428.104L980.852 428.106L980.853 428.559L981.335 428.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.438 428.563L979.437 428.11L978.955 428.111L978.956 428.565L979.438 428.563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.37 430.264L1018.37 429.752L1017.82 429.754L1017.82 430.265L1018.37 430.264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.47 430.269L1016.47 429.758L1015.93 429.759L1015.93 430.271L1016.47 430.269Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.57 430.275L1014.57 429.763L1014.03 429.765L1014.03 430.276L1014.57 430.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.68 430.28L1012.67 429.769L1012.13 429.771L1012.13 430.282L1012.68 430.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.78 430.286L1010.78 429.775L1010.23 429.776L1010.24 430.288L1010.78 430.286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.88 430.292L1008.88 429.78L1008.34 429.782L1008.34 430.293L1008.88 430.292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.98 430.297L1006.98 429.786L1006.44 429.787L1006.44 430.299L1006.98 430.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.09 430.303L1005.09 429.791L1004.54 429.793L1004.54 430.304L1005.09 430.303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.19 430.308L1003.19 429.797L1002.65 429.799L1002.65 430.31L1003.19 430.308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.29 430.314L1001.29 429.803L1000.75 429.804L1000.75 430.316L1001.29 430.314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.395 430.32L999.394 429.808L998.851 429.81L998.852 430.321L999.395 430.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.498 430.325L997.497 429.814L996.953 429.815L996.955 430.327L997.498 430.325Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.601 430.331L995.599 429.819L995.056 429.821L995.057 430.332L995.601 430.331Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.704 430.336L993.702 429.825L993.159 429.827L993.16 430.338L993.704 430.336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.806 430.342L991.805 429.831L991.261 429.832L991.263 430.344L991.806 430.342Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.909 430.348L989.907 429.836L989.364 429.838L989.366 430.349L989.909 430.348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.012 430.353L988.01 429.842L987.467 429.843L987.468 430.355L988.012 430.353Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.114 430.359L986.113 429.847L985.57 429.849L985.571 430.36L986.114 430.359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.217 430.364L984.216 429.853L983.672 429.855L983.674 430.366L984.217 430.364Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.32 430.37L982.318 429.859L981.775 429.86L981.777 430.372L982.32 430.37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.423 430.376L980.421 429.864L979.878 429.866L979.879 430.377L980.423 430.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 432.081L1017.45 431.512L1016.85 431.514L1016.85 432.083L1017.46 432.081Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.56 432.087L1015.56 431.518L1014.95 431.519L1014.95 432.089L1015.56 432.087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.66 432.093L1013.66 431.523L1013.05 431.525L1013.06 432.094L1013.66 432.093Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.76 432.098L1011.76 431.529L1011.16 431.53L1011.16 432.1L1011.76 432.098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.87 432.104L1009.86 431.534L1009.26 431.536L1009.26 432.106L1009.87 432.104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.97 432.109L1007.97 431.54L1007.36 431.542L1007.36 432.111L1007.97 432.109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.07 432.115L1006.07 431.546L1005.47 431.547L1005.47 432.117L1006.07 432.115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.17 432.121L1004.17 431.551L1003.57 431.553L1003.57 432.122L1004.17 432.121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.28 432.126L1002.28 431.557L1001.67 431.559L1001.67 432.128L1002.28 432.126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.38 432.132L1000.38 431.562L999.774 431.564L999.775 432.134L1000.38 432.132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.483 432.137L998.481 431.568L997.876 431.57L997.878 432.139L998.483 432.137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.586 432.143L996.584 431.574L995.979 431.575L995.981 432.145L996.586 432.143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.688 432.149L994.687 431.579L994.082 431.581L994.083 432.15L994.688 432.149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.791 432.154L992.789 431.585L992.184 431.587L992.186 432.156L992.791 432.154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.894 432.16L990.892 431.59L990.287 431.592L990.289 432.162L990.894 432.16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.997 432.165L988.995 431.596L988.39 431.598L988.392 432.167L988.997 432.165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.099 432.171L987.098 431.602L986.493 431.603L986.494 432.173L987.099 432.171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.202 432.177L985.2 431.607L984.595 431.609L984.597 432.178L985.202 432.177Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.305 432.182L983.303 431.613L982.698 431.615L982.7 432.184L983.305 432.182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.407 432.188L981.406 431.618L980.801 431.62L980.803 432.19L981.407 432.188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.51 432.193L979.508 431.624L978.904 431.626L978.905 432.195L979.51 432.193Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.44 433.892L1018.44 433.268L1017.77 433.27L1017.78 433.894L1018.44 433.892Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.54 433.897L1016.54 433.273L1015.88 433.275L1015.88 433.899L1016.54 433.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.64 433.903L1014.64 433.279L1013.98 433.281L1013.98 433.905L1014.64 433.903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.75 433.909L1012.74 433.285L1012.08 433.287L1012.08 433.911L1012.75 433.909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.85 433.914L1010.85 433.29L1010.18 433.292L1010.19 433.916L1010.85 433.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.95 433.92L1008.95 433.296L1008.29 433.298L1008.29 433.922L1008.95 433.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.05 433.925L1007.05 433.301L1006.39 433.303L1006.39 433.927L1007.05 433.925Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.16 433.931L1005.16 433.307L1004.49 433.309L1004.49 433.933L1005.16 433.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.26 433.937L1003.26 433.313L1002.6 433.315L1002.6 433.939L1003.26 433.937Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.36 433.942L1001.36 433.318L1000.7 433.32L1000.7 433.944L1001.36 433.942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.466 433.948L999.464 433.324L998.801 433.326L998.803 433.95L999.466 433.948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.569 433.953L997.567 433.329L996.904 433.331L996.906 433.955L997.569 433.953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.671 433.959L995.669 433.335L995.007 433.337L995.008 433.961L995.671 433.959Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.774 433.965L993.772 433.341L993.109 433.343L993.111 433.967L993.774 433.965Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.877 433.97L991.875 433.346L991.212 433.348L991.214 433.972L991.877 433.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.979 433.976L989.978 433.352L989.315 433.354L989.317 433.978L989.979 433.976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.082 433.981L988.08 433.357L987.418 433.359L987.419 433.983L988.082 433.981Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.185 433.987L986.183 433.363L985.52 433.365L985.522 433.989L986.185 433.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.288 433.993L984.286 433.369L983.623 433.371L983.625 433.995L984.288 433.993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.39 433.998L982.389 433.374L981.726 433.376L981.728 434L982.39 433.998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.493 434.004L980.491 433.38L979.828 433.382L979.83 434.006L980.493 434.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.53 435.71L1017.52 435.028L1016.8 435.03L1016.8 435.712L1017.53 435.71Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.63 435.715L1015.63 435.033L1014.9 435.035L1014.9 435.717L1015.63 435.715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.73 435.721L1013.73 435.039L1013.01 435.041L1013.01 435.723L1013.73 435.721Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.83 435.726L1011.83 435.044L1011.11 435.047L1011.11 435.729L1011.83 435.726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.94 435.732L1009.93 435.05L1009.21 435.052L1009.21 435.734L1009.94 435.732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.04 435.738L1008.04 435.056L1007.31 435.058L1007.32 435.74L1008.04 435.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.14 435.743L1006.14 435.061L1005.42 435.063L1005.42 435.745L1006.14 435.743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.25 435.749L1004.24 435.067L1003.52 435.069L1003.52 435.751L1004.25 435.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.35 435.754L1002.35 435.072L1001.62 435.075L1001.62 435.757L1002.35 435.754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.45 435.76L1000.45 435.078L999.724 435.08L999.726 435.762L1000.45 435.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.553 435.766L998.551 435.084L997.827 435.086L997.829 435.768L998.553 435.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.656 435.771L996.654 435.089L995.93 435.091L995.932 435.773L996.656 435.771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.759 435.777L994.757 435.095L994.032 435.097L994.034 435.779L994.759 435.777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.862 435.782L992.86 435.1L992.135 435.103L992.137 435.785L992.862 435.782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.964 435.788L990.962 435.106L990.238 435.108L990.24 435.79L990.964 435.788Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.067 435.794L989.065 435.112L988.341 435.114L988.343 435.796L989.067 435.794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.17 435.799L987.168 435.117L986.443 435.119L986.445 435.801L987.17 435.799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.272 435.805L985.27 435.123L984.546 435.125L984.548 435.807L985.272 435.805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.375 435.81L983.373 435.129L982.649 435.131L982.651 435.813L983.375 435.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.478 435.816L981.476 435.134L980.751 435.136L980.754 435.818L981.478 435.816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.581 435.822L979.579 435.14L978.854 435.142L978.856 435.824L979.581 435.822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.51 437.522L1018.51 436.782L1017.72 436.784L1017.72 437.524L1018.51 437.522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.61 437.527L1016.61 436.787L1015.83 436.79L1015.83 437.53L1016.61 437.527Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.72 437.533L1014.71 436.793L1013.93 436.795L1013.93 437.535L1014.72 437.533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.82 437.539L1012.82 436.799L1012.03 436.801L1012.03 437.541L1012.82 437.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.92 437.544L1010.92 436.804L1010.13 436.807L1010.14 437.547L1010.92 437.544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.02 437.55L1009.02 436.81L1008.24 436.812L1008.24 437.552L1009.02 437.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.13 437.555L1007.12 436.815L1006.34 436.818L1006.34 437.558L1007.13 437.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.23 437.561L1005.23 436.821L1004.44 436.823L1004.44 437.563L1005.23 437.561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.33 437.567L1003.33 436.827L1002.54 436.829L1002.55 437.569L1003.33 437.567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.44 437.572L1001.43 436.832L1000.65 436.835L1000.65 437.575L1001.44 437.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.538 437.578L999.536 436.838L998.75 436.84L998.752 437.58L999.538 437.578Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.641 437.583L997.639 436.843L996.853 436.846L996.855 437.586L997.641 437.583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.744 437.589L995.741 436.849L994.955 436.851L994.958 437.591L995.744 437.589Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.846 437.595L993.844 436.855L993.058 436.857L993.06 437.597L993.846 437.595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.949 437.6L991.947 436.86L991.161 436.863L991.163 437.603L991.949 437.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.052 437.606L990.05 436.866L989.264 436.868L989.266 437.608L990.052 437.606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.155 437.611L988.152 436.872L987.366 436.874L987.369 437.614L988.155 437.611Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.257 437.617L986.255 436.877L985.469 436.879L985.471 437.619L986.257 437.617Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.36 437.623L984.358 436.883L983.572 436.885L983.574 437.625L984.36 437.623Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.463 437.628L982.461 436.888L981.675 436.891L981.677 437.631L982.463 437.628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.565 437.634L980.563 436.894L979.777 436.896L979.779 437.636L980.565 437.634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.6 439.338L1017.59 438.543L1016.75 438.546L1016.75 439.34L1017.6 439.338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.7 439.343L1015.7 438.549L1014.85 438.551L1014.86 439.346L1015.7 439.343Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.8 439.349L1013.8 438.555L1012.96 438.557L1012.96 439.352L1013.8 439.349Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.9 439.355L1011.9 438.56L1011.06 438.563L1011.06 439.357L1011.9 439.355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.01 439.36L1010.01 438.566L1009.16 438.568L1009.16 439.363L1010.01 439.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.11 439.366L1008.11 438.571L1007.26 438.574L1007.27 439.368L1008.11 439.366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.21 439.371L1006.21 438.577L1005.37 438.579L1005.37 439.374L1006.21 439.371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.32 439.377L1004.31 438.583L1003.47 438.585L1003.47 439.38L1004.32 439.377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.42 439.383L1002.42 438.588L1001.57 438.591L1001.57 439.385L1002.42 439.383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.52 439.388L1000.52 438.594L999.675 438.596L999.677 439.391L1000.52 439.388Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.624 439.394L998.621 438.599L997.778 438.602L997.78 439.396L998.624 439.394Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.727 439.4L996.724 438.605L995.88 438.608L995.883 439.402L996.727 439.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.829 439.405L994.827 438.611L993.983 438.613L993.985 439.408L994.829 439.405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.932 439.411L992.93 438.616L992.086 438.619L992.088 439.413L992.932 439.411Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.035 439.416L991.032 438.622L990.188 438.624L990.191 439.419L991.035 439.416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.137 439.422L989.135 438.627L988.291 438.63L988.294 439.424L989.137 439.422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.24 439.428L987.238 438.633L986.394 438.636L986.396 439.43L987.24 439.428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.343 439.433L985.341 438.639L984.497 438.641L984.499 439.436L985.343 439.433Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.446 439.439L983.443 438.644L982.599 438.647L982.602 439.441L983.446 439.439Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.548 439.444L981.546 438.65L980.702 438.652L980.704 439.447L981.548 439.444Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.651 439.45L979.649 438.655L978.805 438.658L978.807 439.452L979.651 439.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.58 441.15L1018.58 440.298L1017.67 440.3L1017.68 441.153L1018.58 441.15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.68 441.156L1016.68 440.303L1015.78 440.306L1015.78 441.158L1016.68 441.156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.79 441.161L1014.78 440.309L1013.88 440.311L1013.88 441.164L1014.79 441.161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.89 441.167L1012.89 440.314L1011.98 440.317L1011.98 441.17L1012.89 441.167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.99 441.172L1010.99 440.32L1010.08 440.323L1010.09 441.175L1010.99 441.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.09 441.178L1009.09 440.326L1008.19 440.328L1008.19 441.181L1009.09 441.178Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 441.184L1007.2 440.331L1006.29 440.334L1006.29 441.186L1007.2 441.184Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.3 441.189L1005.3 440.337L1004.39 440.339L1004.39 441.192L1005.3 441.189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.4 441.195L1003.4 440.342L1002.5 440.345L1002.5 441.198L1003.4 441.195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.51 441.2L1001.5 440.348L1000.6 440.351L1000.6 441.203L1001.51 441.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.609 441.206L999.606 440.354L998.701 440.356L998.703 441.209L999.609 441.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.711 441.212L997.709 440.359L996.803 440.362L996.806 441.214L997.711 441.212Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.814 441.217L995.812 440.365L994.906 440.368L994.909 441.22L995.814 441.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.917 441.223L993.914 440.37L993.009 440.373L993.011 441.226L993.917 441.223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.02 441.228L992.017 440.376L991.111 440.379L991.114 441.231L992.02 441.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.122 441.234L990.12 440.382L989.214 440.384L989.217 441.237L990.122 441.234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.225 441.24L988.222 440.387L987.317 440.39L987.319 441.242L988.225 441.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.328 441.245L986.325 440.393L985.42 440.396L985.422 441.248L986.328 441.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.43 441.251L984.428 440.398L983.522 440.401L983.525 441.254L984.43 441.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.533 441.257L982.531 440.404L981.625 440.407L981.628 441.259L982.533 441.257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.636 441.262L980.633 440.41L979.728 440.412L979.73 441.265L980.636 441.262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.67 442.968L1017.67 442.057L1016.7 442.06L1016.7 442.971L1017.67 442.968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.77 442.973L1015.77 442.063L1014.8 442.066L1014.8 442.976L1015.77 442.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.87 442.979L1013.87 442.069L1012.9 442.071L1012.91 442.982L1013.87 442.979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.98 442.985L1011.97 442.074L1011.01 442.077L1011.01 442.987L1011.98 442.985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.08 442.99L1010.08 442.08L1009.11 442.083L1009.11 442.993L1010.08 442.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.18 442.996L1008.18 442.085L1007.21 442.088L1007.22 442.999L1008.18 442.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.29 443.001L1006.28 442.091L1005.32 442.094L1005.32 443.004L1006.29 443.001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.39 443.007L1004.39 442.097L1003.42 442.099L1003.42 443.01L1004.39 443.007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.49 443.013L1002.49 442.102L1001.52 442.105L1001.52 443.016L1002.49 443.013Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.59 443.018L1000.59 442.108L999.624 442.111L999.626 443.021L1000.59 443.018Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.696 443.024L998.693 442.113L997.726 442.116L997.729 443.027L998.696 443.024Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.799 443.029L996.796 442.119L995.829 442.122L995.832 443.032L996.799 443.029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.902 443.035L994.899 442.125L993.932 442.128L993.934 443.038L994.902 443.035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.004 443.041L993.002 442.13L992.035 442.133L992.037 443.044L993.004 443.041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.107 443.046L991.104 442.136L990.137 442.139L990.14 443.049L991.107 443.046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.21 443.052L989.207 442.141L988.24 442.144L988.243 443.055L989.21 443.052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.313 443.057L987.31 442.147L986.343 442.15L986.345 443.06L987.313 443.057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.415 443.063L985.413 442.153L984.445 442.156L984.448 443.066L985.415 443.063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.518 443.069L983.515 442.158L982.548 442.161L982.551 443.072L983.518 443.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.621 443.074L981.618 442.164L980.651 442.167L980.654 443.077L981.621 443.074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.65 444.778L1018.65 443.813L1017.62 443.816L1017.63 444.781L1018.65 444.778Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.75 444.784L1016.75 443.819L1015.73 443.822L1015.73 444.787L1016.75 444.784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.86 444.79L1014.85 443.825L1013.83 443.828L1013.83 444.793L1014.86 444.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.96 444.795L1012.96 443.83L1011.93 443.833L1011.93 444.798L1012.96 444.795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.06 444.801L1011.06 443.836L1010.03 443.839L1010.04 444.804L1011.06 444.801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.17 444.806L1009.16 443.841L1008.14 443.844L1008.14 444.809L1009.17 444.806Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.27 444.812L1007.27 443.847L1006.24 443.85L1006.24 444.815L1007.27 444.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.37 444.818L1005.37 443.853L1004.34 443.856L1004.35 444.821L1005.37 444.818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.47 444.823L1003.47 443.858L1002.45 443.861L1002.45 444.826L1003.47 444.823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.58 444.829L1001.57 443.864L1000.55 443.867L1000.55 444.832L1001.58 444.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.679 444.834L999.676 443.869L998.651 443.872L998.654 444.837L999.679 444.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.782 444.84L997.779 443.875L996.754 443.878L996.757 444.843L997.782 444.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.885 444.846L995.882 443.881L994.857 443.884L994.859 444.849L995.885 444.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.987 444.851L993.984 443.886L992.959 443.889L992.962 444.854L993.987 444.851Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.09 444.857L992.087 443.892L991.062 443.895L991.065 444.86L992.09 444.857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.193 444.862L990.19 443.897L989.165 443.9L989.168 444.865L990.193 444.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.295 444.868L988.293 443.903L987.268 443.906L987.27 444.871L988.295 444.868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.398 444.874L986.395 443.909L985.37 443.912L985.373 444.877L986.398 444.874Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.501 444.879L984.498 443.914L983.473 443.917L983.476 444.882L984.501 444.879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.604 444.885L982.601 443.92L981.576 443.923L981.579 444.888L982.604 444.885Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.706 444.89L980.704 443.925L979.679 443.928L979.681 444.893L980.706 444.89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.74 446.596L1017.74 445.573L1016.65 445.576L1016.65 446.599L1017.74 446.596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.84 446.602L1015.84 445.579L1014.75 445.582L1014.76 446.605L1015.84 446.602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.94 446.607L1013.94 445.584L1012.86 445.588L1012.86 446.61L1013.94 446.607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.05 446.613L1012.04 445.59L1010.96 445.593L1010.96 446.616L1012.05 446.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.15 446.618L1010.15 445.596L1009.06 445.599L1009.06 446.622L1010.15 446.618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.25 446.624L1008.25 445.601L1007.16 445.604L1007.17 446.627L1008.25 446.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.36 446.63L1006.35 445.607L1005.27 445.61L1005.27 446.633L1006.36 446.63Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.46 446.635L1004.46 445.612L1003.37 445.616L1003.37 446.639L1004.46 446.635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.56 446.641L1002.56 445.618L1001.47 445.621L1001.47 446.644L1002.56 446.641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.66 446.647L1000.66 445.624L999.574 445.627L999.577 446.65L1000.66 446.647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.767 446.652L998.764 445.629L997.677 445.632L997.68 446.655L998.767 446.652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.869 446.658L996.866 445.635L995.78 445.638L995.783 446.661L996.869 446.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.972 446.663L994.969 445.64L993.882 445.644L993.885 446.667L994.972 446.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.075 446.669L993.072 445.646L991.985 445.649L991.988 446.672L993.075 446.669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.178 446.675L991.174 445.652L990.088 445.655L990.091 446.678L991.178 446.675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.28 446.68L989.277 445.657L988.191 445.66L988.194 446.683L989.28 446.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.383 446.686L987.38 445.663L986.293 445.666L986.296 446.689L987.383 446.686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.486 446.691L985.483 445.668L984.396 445.672L984.399 446.695L985.486 446.691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.588 446.697L983.585 445.674L982.499 445.677L982.502 446.7L983.588 446.697Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.691 446.703L981.688 445.68L980.602 445.683L980.605 446.706L981.691 446.703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.72 448.408L1018.72 447.327L1017.57 447.331L1017.58 448.412L1018.72 448.408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.83 448.414L1016.82 447.333L1015.68 447.336L1015.68 448.417L1016.83 448.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.93 448.419L1014.93 447.339L1013.78 447.342L1013.78 448.423L1014.93 448.419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.03 448.425L1013.03 447.344L1011.88 447.348L1011.88 448.428L1013.03 448.425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.13 448.431L1011.13 447.35L1009.98 447.353L1009.99 448.434L1011.13 448.431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.24 448.436L1009.23 447.355L1008.09 447.359L1008.09 448.44L1009.24 448.436Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.34 448.442L1007.34 447.361L1006.19 447.364L1006.19 448.445L1007.34 448.442Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.44 448.447L1005.44 447.367L1004.29 447.37L1004.29 448.451L1005.44 448.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.55 448.453L1003.54 447.372L1002.39 447.376L1002.4 448.456L1003.55 448.453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.65 448.459L1001.65 447.378L1000.5 447.381L1000.5 448.462L1001.65 448.459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.751 448.464L999.748 447.383L998.6 447.387L998.603 448.468L999.751 448.464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.854 448.47L997.851 447.389L996.703 447.392L996.706 448.473L997.854 448.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.957 448.476L995.954 447.395L994.805 447.398L994.809 448.479L995.957 448.476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.06 448.481L994.056 447.4L992.908 447.404L992.911 448.484L994.06 448.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.162 448.487L992.159 447.406L991.011 447.409L991.014 448.49L992.162 448.487Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.265 448.492L990.262 447.411L989.114 447.415L989.117 448.496L990.265 448.492Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.368 448.498L988.365 447.417L987.216 447.42L987.22 448.501L988.368 448.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.47 448.504L986.467 447.423L985.319 447.426L985.322 448.507L986.47 448.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.573 448.509L984.57 447.428L983.422 447.432L983.425 448.513L984.573 448.509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.676 448.515L982.673 447.434L981.525 447.437L981.528 448.518L982.676 448.515Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.81 450.224L1017.81 449.089L1016.6 449.092L1016.6 450.228L1017.81 450.224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.91 450.23L1015.91 449.094L1014.7 449.098L1014.71 450.234L1015.91 450.23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.02 450.236L1014.01 449.1L1012.81 449.104L1012.81 450.239L1014.02 450.236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.12 450.241L1012.11 449.106L1010.91 449.109L1010.91 450.245L1012.12 450.241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.22 450.247L1010.22 449.111L1009.01 449.115L1009.01 450.25L1010.22 450.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.32 450.252L1008.32 449.117L1007.11 449.12L1007.12 450.256L1008.32 450.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.43 450.258L1006.42 449.123L1005.22 449.126L1005.22 450.262L1006.43 450.258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.53 450.264L1004.53 449.128L1003.32 449.132L1003.32 450.267L1004.53 450.264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.63 450.269L1002.63 449.134L1001.42 449.137L1001.43 450.273L1002.63 450.269Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.73 450.275L1000.73 449.139L999.525 449.143L999.528 450.278L1000.73 450.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.837 450.28L998.834 449.145L997.628 449.148L997.631 450.284L998.837 450.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.94 450.286L996.936 449.151L995.73 449.154L995.734 450.29L996.94 450.286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.043 450.292L995.039 449.156L993.833 449.16L993.836 450.295L995.043 450.292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.145 450.297L993.142 449.162L991.936 449.165L991.939 450.301L993.145 450.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.248 450.303L991.245 449.167L990.039 449.171L990.042 450.306L991.248 450.303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.351 450.308L989.347 449.173L988.141 449.176L988.145 450.312L989.351 450.308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.453 450.314L987.45 449.179L986.244 449.182L986.247 450.318L987.453 450.314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.556 450.32L985.553 449.184L984.347 449.188L984.35 450.323L985.556 450.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.659 450.325L983.656 449.19L982.449 449.193L982.453 450.329L983.659 450.325Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.79 452.037L1018.79 450.843L1017.52 450.847L1017.53 452.04L1018.79 452.037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.9 452.042L1016.89 450.849L1015.63 450.852L1015.63 452.046L1016.9 452.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015 452.048L1015 450.854L1013.73 450.858L1013.73 452.051L1015 452.048Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.1 452.053L1013.1 450.86L1011.83 450.864L1011.84 452.057L1013.1 452.053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.21 452.059L1011.2 450.866L1009.93 450.869L1009.94 452.063L1011.21 452.059Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.31 452.065L1009.3 450.871L1008.04 450.875L1008.04 452.068L1009.31 452.065Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.41 452.07L1007.41 450.877L1006.14 450.88L1006.14 452.074L1007.41 452.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.51 452.076L1005.51 450.882L1004.24 450.886L1004.25 452.079L1005.51 452.076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.62 452.081L1003.61 450.888L1002.35 450.892L1002.35 452.085L1003.62 452.081Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.72 452.087L1001.72 450.894L1000.45 450.897L1000.45 452.091L1001.72 452.087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.822 452.093L999.818 450.899L998.551 450.903L998.554 452.096L999.822 452.093Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.925 452.098L997.921 450.905L996.653 450.908L996.657 452.102L997.925 452.098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.027 452.104L996.024 450.91L994.756 450.914L994.76 452.108L996.027 452.104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.13 452.109L994.127 450.916L992.859 450.92L992.862 452.113L994.13 452.109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.233 452.115L992.229 450.922L990.962 450.925L990.965 452.119L992.233 452.115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.336 452.121L990.332 450.927L989.064 450.931L989.068 452.124L990.336 452.121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.438 452.126L988.435 450.933L987.167 450.936L987.171 452.13L988.438 452.126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.541 452.132L986.537 450.938L985.27 450.942L985.273 452.136L986.541 452.132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.644 452.137L984.64 450.944L983.372 450.948L983.376 452.141L984.644 452.137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.88 453.854L1017.88 452.603L1016.55 452.607L1016.55 453.858L1017.88 453.854Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.98 453.86L1015.98 452.609L1014.65 452.612L1014.66 453.864L1015.98 453.86Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.09 453.866L1014.08 452.614L1012.75 452.618L1012.76 453.869L1014.09 453.866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.19 453.871L1012.19 452.62L1010.86 452.624L1010.86 453.875L1012.19 453.871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.29 453.877L1010.29 452.625L1008.96 452.629L1008.96 453.881L1010.29 453.877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.4 453.882L1008.39 452.631L1007.06 452.635L1007.07 453.886L1008.4 453.882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.5 453.888L1006.49 452.637L1005.17 452.64L1005.17 453.892L1006.5 453.888Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.6 453.894L1004.6 452.642L1003.27 452.646L1003.27 453.897L1004.6 453.894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.7 453.899L1002.7 452.648L1001.37 452.652L1001.37 453.903L1002.7 453.899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.81 453.905L1000.8 452.653L999.474 452.657L999.477 453.909L1000.81 453.905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.909 453.91L998.906 452.659L997.576 452.663L997.58 453.914L998.909 453.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.012 453.916L997.008 452.665L995.679 452.668L995.683 453.92L997.012 453.916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.115 453.922L995.111 452.67L993.782 452.674L993.786 453.925L995.115 453.922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.218 453.927L993.214 452.676L991.885 452.68L991.888 453.931L993.218 453.927Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.32 453.933L991.317 452.681L989.987 452.685L989.991 453.937L991.32 453.933Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.423 453.938L989.419 452.687L988.09 452.691L988.094 453.942L989.423 453.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.526 453.944L987.522 452.693L986.193 452.696L986.196 453.948L987.526 453.944Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.628 453.95L985.625 452.698L984.296 452.702L984.299 453.953L985.628 453.95Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.731 453.955L983.728 452.704L982.398 452.708L982.402 453.959L983.731 453.955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.87 455.665L1018.86 454.359L1017.47 454.363L1017.48 455.669L1018.87 455.665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.97 455.67L1016.96 454.364L1015.58 454.369L1015.58 455.674L1016.97 455.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.07 455.676L1015.07 454.37L1013.68 454.374L1013.68 455.68L1015.07 455.676Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.17 455.682L1013.17 454.376L1011.78 454.38L1011.79 455.686L1013.17 455.682Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.28 455.687L1011.27 454.381L1009.88 454.385L1009.89 455.691L1011.28 455.687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.38 455.693L1009.37 454.387L1007.99 454.391L1007.99 455.697L1009.38 455.693Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.48 455.698L1007.48 454.392L1006.09 454.397L1006.09 455.703L1007.48 455.698Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.58 455.704L1005.58 454.398L1004.19 454.402L1004.2 455.708L1005.58 455.704Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.69 455.71L1003.68 454.404L1002.3 454.408L1002.3 455.714L1003.69 455.71Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.79 455.715L1001.79 454.409L1000.4 454.413L1000.4 455.719L1001.79 455.715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.892 455.721L999.888 454.415L998.501 454.419L998.505 455.725L999.892 455.721Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.995 455.726L997.991 454.42L996.604 454.425L996.608 455.731L997.995 455.726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.098 455.732L996.094 454.426L994.707 454.43L994.711 455.736L996.098 455.732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.201 455.738L994.197 454.432L992.809 454.436L992.813 455.742L994.201 455.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.303 455.743L992.299 454.437L990.912 454.441L990.916 455.747L992.303 455.743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.406 455.749L990.402 454.443L989.015 454.447L989.019 455.753L990.406 455.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.509 455.754L988.505 454.448L987.118 454.453L987.121 455.759L988.509 455.754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.611 455.76L986.608 454.454L985.22 454.458L985.224 455.764L986.611 455.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.714 455.766L984.71 454.46L983.323 454.464L983.327 455.77L984.714 455.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.817 455.771L982.813 454.465L981.426 454.469L981.43 455.775L982.817 455.771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.95 457.483L1017.95 456.119L1016.5 456.123L1016.5 457.487L1017.95 457.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.06 457.488L1016.05 456.124L1014.6 456.129L1014.61 457.492L1016.06 457.488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.16 457.494L1014.15 456.13L1012.71 456.134L1012.71 457.498L1014.16 457.494Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.26 457.499L1012.26 456.135L1010.81 456.14L1010.81 457.504L1012.26 457.499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.36 457.505L1010.36 456.141L1008.91 456.145L1008.91 457.509L1010.36 457.505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.47 457.511L1008.46 456.147L1007.01 456.151L1007.02 457.515L1008.47 457.511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.57 457.516L1006.56 456.152L1005.12 456.157L1005.12 457.52L1006.57 457.516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.67 457.522L1004.67 456.158L1003.22 456.162L1003.22 457.526L1004.67 457.522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.77 457.527L1002.77 456.163L1001.32 456.168L1001.33 457.532L1002.77 457.527Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.88 457.533L1000.87 456.169L999.424 456.173L999.428 457.537L1000.88 457.533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.98 457.539L998.976 456.175L997.527 456.179L997.531 457.543L998.98 457.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.083 457.544L997.079 456.18L995.63 456.185L995.634 457.548L997.083 457.544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.185 457.55L995.181 456.186L993.732 456.19L993.736 457.554L995.185 457.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.288 457.555L993.284 456.191L991.835 456.196L991.839 457.56L993.288 457.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.391 457.561L991.387 456.197L989.938 456.201L989.942 457.565L991.391 457.561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.494 457.567L989.489 456.203L988.041 456.207L988.045 457.571L989.494 457.567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.596 457.572L987.592 456.208L986.143 456.213L986.147 457.577L987.596 457.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.699 457.578L985.695 456.214L984.246 456.218L984.25 457.582L985.699 457.578Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.802 457.583L983.798 456.22L982.349 456.224L982.353 457.588L983.802 457.583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.39 421.088L1052.39 420.859L1052.15 420.86L1052.15 421.089L1052.39 421.088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.5 421.094L1050.5 420.865L1050.25 420.866L1050.25 421.094L1050.5 421.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.6 421.099L1048.6 420.871L1048.36 420.871L1048.36 421.1L1048.6 421.099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.7 421.105L1046.7 420.876L1046.46 420.877L1046.46 421.105L1046.7 421.105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.8 421.11L1044.8 420.882L1044.56 420.883L1044.56 421.111L1044.8 421.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.91 421.116L1042.91 420.887L1042.66 420.888L1042.67 421.117L1042.91 421.116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.01 421.122L1041.01 420.893L1040.77 420.894L1040.77 421.122L1041.01 421.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.11 421.127L1039.11 420.899L1038.87 420.899L1038.87 421.128L1039.11 421.127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.22 421.133L1037.22 420.904L1036.97 420.905L1036.97 421.133L1037.22 421.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.32 421.138L1035.32 420.91L1035.08 420.911L1035.08 421.139L1035.32 421.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.42 421.144L1033.42 420.915L1033.18 420.916L1033.18 421.145L1033.42 421.144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.52 421.15L1031.52 420.921L1031.28 420.922L1031.28 421.15L1031.52 421.15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.63 421.155L1029.63 420.927L1029.38 420.927L1029.38 421.156L1029.63 421.155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.73 421.161L1027.73 420.932L1027.49 420.933L1027.49 421.161L1027.73 421.161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.83 421.166L1025.83 420.938L1025.59 420.939L1025.59 421.167L1025.83 421.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.94 421.172L1023.93 420.943L1023.69 420.944L1023.69 421.173L1023.94 421.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.04 421.178L1022.04 420.949L1021.79 420.95L1021.8 421.178L1022.04 421.178Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.14 421.183L1020.14 420.955L1019.9 420.955L1019.9 421.184L1020.14 421.183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.24 421.189L1018.24 420.96L1018 420.961L1018 421.189L1018.24 421.189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.38 422.898L1053.38 422.615L1053.08 422.616L1053.08 422.899L1053.38 422.898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.48 422.904L1051.48 422.621L1051.18 422.622L1051.18 422.905L1051.48 422.904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.58 422.91L1049.58 422.627L1049.28 422.627L1049.28 422.91L1049.58 422.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.69 422.915L1047.68 422.632L1047.38 422.633L1047.38 422.916L1047.69 422.915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.79 422.921L1045.79 422.638L1045.49 422.639L1045.49 422.922L1045.79 422.921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.89 422.926L1043.89 422.643L1043.59 422.644L1043.59 422.927L1043.89 422.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.99 422.932L1041.99 422.649L1041.69 422.65L1041.69 422.933L1041.99 422.932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.1 422.938L1040.1 422.655L1039.79 422.655L1039.8 422.938L1040.1 422.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.2 422.943L1038.2 422.66L1037.9 422.661L1037.9 422.944L1038.2 422.943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.3 422.949L1036.3 422.666L1036 422.667L1036 422.95L1036.3 422.949Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.4 422.954L1034.4 422.671L1034.1 422.672L1034.1 422.955L1034.4 422.954Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.51 422.96L1032.51 422.677L1032.21 422.678L1032.21 422.961L1032.51 422.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.61 422.966L1030.61 422.683L1030.31 422.683L1030.31 422.967L1030.61 422.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.71 422.971L1028.71 422.688L1028.41 422.689L1028.41 422.972L1028.71 422.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.82 422.977L1026.81 422.694L1026.51 422.695L1026.51 422.978L1026.82 422.977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.92 422.982L1024.92 422.699L1024.62 422.7L1024.62 422.983L1024.92 422.982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.02 422.988L1023.02 422.705L1022.72 422.706L1022.72 422.989L1023.02 422.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.12 422.994L1021.12 422.711L1020.82 422.712L1020.82 422.995L1021.12 422.994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.23 422.999L1019.23 422.716L1018.92 422.717L1018.93 423L1019.23 422.999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.36 424.711L1054.36 424.37L1054 424.371L1054 424.712L1054.36 424.711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.46 424.716L1052.46 424.375L1052.1 424.376L1052.1 424.717L1052.46 424.716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.57 424.722L1050.57 424.381L1050.2 424.382L1050.21 424.723L1050.57 424.722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.67 424.727L1048.67 424.386L1048.31 424.387L1048.31 424.728L1048.67 424.727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.77 424.733L1046.77 424.392L1046.41 424.393L1046.41 424.734L1046.77 424.733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.88 424.739L1044.87 424.398L1044.51 424.399L1044.51 424.74L1044.88 424.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.98 424.744L1042.98 424.403L1042.61 424.404L1042.62 424.745L1042.98 424.744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.08 424.75L1041.08 424.409L1040.72 424.41L1040.72 424.751L1041.08 424.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.18 424.755L1039.18 424.414L1038.82 424.415L1038.82 424.756L1039.18 424.755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.29 424.761L1037.29 424.42L1036.92 424.421L1036.92 424.762L1037.29 424.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.39 424.767L1035.39 424.426L1035.03 424.427L1035.03 424.768L1035.39 424.767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.49 424.772L1033.49 424.431L1033.13 424.432L1033.13 424.773L1033.49 424.772Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.59 424.778L1031.59 424.437L1031.23 424.438L1031.23 424.779L1031.59 424.778Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.7 424.783L1029.7 424.442L1029.33 424.443L1029.34 424.784L1029.7 424.783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.8 424.789L1027.8 424.448L1027.44 424.449L1027.44 424.79L1027.8 424.789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.9 424.795L1025.9 424.454L1025.54 424.455L1025.54 424.796L1025.9 424.795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.01 424.8L1024 424.459L1023.64 424.46L1023.64 424.801L1024.01 424.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.11 424.806L1022.11 424.465L1021.75 424.466L1021.75 424.807L1022.11 424.806Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.21 424.811L1020.21 424.47L1019.85 424.472L1019.85 424.812L1020.21 424.811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.31 424.817L1018.31 424.476L1017.95 424.477L1017.95 424.818L1018.31 424.817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.35 426.523L1055.35 426.124L1054.92 426.125L1054.92 426.524L1055.35 426.523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.45 426.528L1053.45 426.129L1053.02 426.131L1053.03 426.53L1053.45 426.528Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.55 426.534L1051.55 426.135L1051.13 426.136L1051.13 426.535L1051.55 426.534Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.65 426.54L1049.65 426.141L1049.23 426.142L1049.23 426.541L1049.65 426.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.76 426.545L1047.76 426.146L1047.33 426.147L1047.33 426.546L1047.76 426.545Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.86 426.551L1045.86 426.152L1045.44 426.153L1045.44 426.552L1045.86 426.551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.96 426.556L1043.96 426.157L1043.54 426.159L1043.54 426.558L1043.96 426.556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.07 426.562L1042.06 426.163L1041.64 426.164L1041.64 426.563L1042.07 426.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.17 426.568L1040.17 426.169L1039.74 426.17L1039.74 426.569L1040.17 426.568Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.27 426.573L1038.27 426.174L1037.85 426.175L1037.85 426.574L1038.27 426.573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.37 426.579L1036.37 426.18L1035.95 426.181L1035.95 426.58L1036.37 426.579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.48 426.584L1034.48 426.185L1034.05 426.187L1034.05 426.586L1034.48 426.584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.58 426.59L1032.58 426.191L1032.15 426.192L1032.16 426.591L1032.58 426.59Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.68 426.596L1030.68 426.197L1030.26 426.198L1030.26 426.597L1030.68 426.596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.78 426.601L1028.78 426.202L1028.36 426.203L1028.36 426.602L1028.78 426.601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.89 426.607L1026.89 426.208L1026.46 426.209L1026.46 426.608L1026.89 426.607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.99 426.612L1024.99 426.213L1024.57 426.215L1024.57 426.614L1024.99 426.612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.09 426.618L1023.09 426.219L1022.67 426.22L1022.67 426.619L1023.09 426.618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.2 426.624L1021.19 426.225L1020.77 426.226L1020.77 426.625L1021.2 426.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.3 426.629L1019.3 426.23L1018.87 426.232L1018.87 426.63L1019.3 426.629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.33 428.333L1056.33 427.88L1055.85 427.881L1055.85 428.335L1056.33 428.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.43 428.339L1054.43 427.885L1053.95 427.887L1053.95 428.34L1054.43 428.339Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.53 428.344L1052.53 427.891L1052.05 427.892L1052.05 428.346L1052.53 428.344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.64 428.35L1050.64 427.897L1050.15 427.898L1050.16 428.351L1050.64 428.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.74 428.356L1048.74 427.902L1048.26 427.904L1048.26 428.357L1048.74 428.356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.84 428.361L1046.84 427.908L1046.36 427.909L1046.36 428.363L1046.84 428.361Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.95 428.367L1044.94 427.913L1044.46 427.915L1044.46 428.368L1044.95 428.367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.05 428.372L1043.05 427.919L1042.57 427.92L1042.57 428.374L1043.05 428.372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.15 428.378L1041.15 427.925L1040.67 427.926L1040.67 428.379L1041.15 428.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.25 428.384L1039.25 427.93L1038.77 427.932L1038.77 428.385L1039.25 428.384Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.36 428.389L1037.36 427.936L1036.87 427.937L1036.88 428.391L1037.36 428.389Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.46 428.395L1035.46 427.941L1034.98 427.943L1034.98 428.396L1035.46 428.395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.56 428.4L1033.56 427.947L1033.08 427.948L1033.08 428.402L1033.56 428.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.67 428.406L1031.66 427.953L1031.18 427.954L1031.18 428.407L1031.67 428.406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.77 428.412L1029.77 427.958L1029.28 427.96L1029.29 428.413L1029.77 428.412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.87 428.417L1027.87 427.964L1027.39 427.965L1027.39 428.419L1027.87 428.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.97 428.423L1025.97 427.969L1025.49 427.971L1025.49 428.424L1025.97 428.423Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.08 428.428L1024.07 427.975L1023.59 427.976L1023.59 428.43L1024.08 428.428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.18 428.434L1022.18 427.981L1021.7 427.982L1021.7 428.436L1022.18 428.434Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.28 428.44L1020.28 427.986L1019.8 427.988L1019.8 428.441L1020.28 428.44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.38 428.445L1018.38 427.992L1017.9 427.993L1017.9 428.447L1018.38 428.445Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.31 430.145L1057.31 429.634L1056.77 429.636L1056.77 430.147L1057.31 430.145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.42 430.151L1055.42 429.64L1054.87 429.641L1054.87 430.153L1055.42 430.151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.52 430.157L1053.52 429.645L1052.97 429.647L1052.98 430.158L1053.52 430.157Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.62 430.162L1051.62 429.651L1051.08 429.652L1051.08 430.164L1051.62 430.162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.73 430.168L1049.72 429.656L1049.18 429.658L1049.18 430.169L1049.73 430.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.83 430.173L1047.83 429.662L1047.28 429.664L1047.28 430.175L1047.83 430.173Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.93 430.179L1045.93 429.668L1045.39 429.669L1045.39 430.181L1045.93 430.179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.03 430.185L1044.03 429.673L1043.49 429.675L1043.49 430.186L1044.03 430.185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.14 430.19L1042.13 429.679L1041.59 429.68L1041.59 430.192L1042.14 430.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.24 430.196L1040.24 429.684L1039.69 429.686L1039.7 430.197L1040.24 430.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.34 430.201L1038.34 429.69L1037.8 429.692L1037.8 430.203L1038.34 430.201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.44 430.207L1036.44 429.696L1035.9 429.697L1035.9 430.209L1036.44 430.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.55 430.213L1034.55 429.701L1034 429.703L1034 430.214L1034.55 430.213Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.65 430.218L1032.65 429.707L1032.11 429.708L1032.11 430.22L1032.65 430.218Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.75 430.224L1030.75 429.712L1030.21 429.714L1030.21 430.225L1030.75 430.224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.86 430.229L1028.85 429.718L1028.31 429.72L1028.31 430.231L1028.86 430.229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.96 430.235L1026.96 429.724L1026.41 429.725L1026.41 430.237L1026.96 430.235Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.06 430.241L1025.06 429.729L1024.52 429.731L1024.52 430.242L1025.06 430.241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.16 430.246L1023.16 429.735L1022.62 429.736L1022.62 430.248L1023.16 430.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.27 430.252L1021.26 429.74L1020.72 429.742L1020.72 430.253L1021.27 430.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.37 430.257L1019.37 429.746L1018.82 429.748L1018.83 430.259L1019.37 430.257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.4 431.963L1056.4 431.394L1055.8 431.396L1055.8 431.965L1056.4 431.963Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.5 431.969L1054.5 431.399L1053.9 431.401L1053.9 431.971L1054.5 431.969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.61 431.974L1052.61 431.405L1052 431.407L1052 431.976L1052.61 431.974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.71 431.98L1050.71 431.411L1050.1 431.412L1050.11 431.982L1050.71 431.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.81 431.986L1048.81 431.416L1048.21 431.418L1048.21 431.987L1048.81 431.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.92 431.991L1046.91 431.422L1046.31 431.424L1046.31 431.993L1046.92 431.991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.02 431.997L1045.02 431.427L1044.41 431.429L1044.41 431.999L1045.02 431.997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.12 432.002L1043.12 431.433L1042.51 431.435L1042.52 432.004L1043.12 432.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.22 432.008L1041.22 431.439L1040.62 431.44L1040.62 432.01L1041.22 432.008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.33 432.014L1039.32 431.444L1038.72 431.446L1038.72 432.015L1039.33 432.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.43 432.019L1037.43 431.45L1036.82 431.452L1036.82 432.021L1037.43 432.019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.53 432.025L1035.53 431.455L1034.93 431.457L1034.93 432.027L1035.53 432.025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.63 432.03L1033.63 431.461L1033.03 431.463L1033.03 432.032L1033.63 432.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.74 432.036L1031.74 431.467L1031.13 431.468L1031.13 432.038L1031.74 432.036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.84 432.042L1029.84 431.472L1029.23 431.474L1029.24 432.043L1029.84 432.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.94 432.047L1027.94 431.478L1027.34 431.48L1027.34 432.049L1027.94 432.047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.05 432.053L1026.04 431.483L1025.44 431.485L1025.44 432.055L1026.05 432.053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.15 432.058L1024.15 431.489L1023.54 431.491L1023.54 432.06L1024.15 432.058Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.25 432.064L1022.25 431.495L1021.64 431.496L1021.65 432.066L1022.25 432.064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.35 432.07L1020.35 431.5L1019.75 431.502L1019.75 432.071L1020.35 432.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.46 432.075L1018.45 431.506L1017.85 431.508L1017.85 432.077L1018.46 432.075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.38 433.774L1057.38 433.15L1056.72 433.152L1056.72 433.776L1057.38 433.774Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.49 433.779L1055.49 433.155L1054.82 433.157L1054.82 433.781L1055.49 433.779Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.59 433.785L1053.59 433.161L1052.93 433.163L1052.93 433.787L1053.59 433.785Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.69 433.79L1051.69 433.166L1051.03 433.168L1051.03 433.792L1051.69 433.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.8 433.796L1049.79 433.172L1049.13 433.174L1049.13 433.798L1049.8 433.796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.9 433.802L1047.9 433.178L1047.23 433.18L1047.24 433.804L1047.9 433.802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046 433.807L1046 433.183L1045.34 433.185L1045.34 433.809L1046 433.807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.1 433.813L1044.1 433.189L1043.44 433.191L1043.44 433.815L1044.1 433.813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.21 433.818L1042.2 433.194L1041.54 433.196L1041.54 433.82L1042.21 433.818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.31 433.824L1040.31 433.2L1039.64 433.202L1039.65 433.826L1040.31 433.824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.41 433.83L1038.41 433.206L1037.75 433.208L1037.75 433.832L1038.41 433.83Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.51 433.835L1036.51 433.211L1035.85 433.213L1035.85 433.837L1036.51 433.835Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.62 433.841L1034.62 433.217L1033.95 433.219L1033.95 433.843L1034.62 433.841Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.72 433.847L1032.72 433.223L1032.06 433.224L1032.06 433.848L1032.72 433.847Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.82 433.852L1030.82 433.228L1030.16 433.23L1030.16 433.854L1030.82 433.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.93 433.858L1028.92 433.234L1028.26 433.236L1028.26 433.86L1028.93 433.858Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.03 433.863L1027.03 433.239L1026.36 433.241L1026.37 433.865L1027.03 433.863Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.13 433.869L1025.13 433.245L1024.47 433.247L1024.47 433.871L1025.13 433.869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.23 433.875L1023.23 433.251L1022.57 433.252L1022.57 433.876L1023.23 433.875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.34 433.88L1021.33 433.256L1020.67 433.258L1020.67 433.882L1021.34 433.88Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.44 433.886L1019.44 433.262L1018.77 433.264L1018.78 433.888L1019.44 433.886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.47 435.591L1056.47 434.909L1055.75 434.912L1055.75 435.594L1056.47 435.591Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.58 435.597L1054.57 434.915L1053.85 434.917L1053.85 435.599L1054.58 435.597Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.68 435.603L1052.68 434.921L1051.95 434.923L1051.95 435.605L1052.68 435.603Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.78 435.608L1050.78 434.926L1050.05 434.928L1050.06 435.61L1050.78 435.608Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.88 435.614L1048.88 434.932L1048.16 434.934L1048.16 435.616L1048.88 435.614Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.99 435.619L1046.98 434.937L1046.26 434.94L1046.26 435.622L1046.99 435.619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 435.625L1045.09 434.943L1044.36 434.945L1044.36 435.627L1045.09 435.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.19 435.631L1043.19 434.949L1042.46 434.951L1042.47 435.633L1043.19 435.631Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.29 435.636L1041.29 434.954L1040.57 434.956L1040.57 435.638L1041.29 435.636Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.4 435.642L1039.39 434.96L1038.67 434.962L1038.67 435.644L1039.4 435.642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.5 435.647L1037.5 434.966L1036.77 434.968L1036.78 435.65L1037.5 435.647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.6 435.653L1035.6 434.971L1034.88 434.973L1034.88 435.655L1035.6 435.653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.71 435.659L1033.7 434.977L1032.98 434.979L1032.98 435.661L1033.71 435.659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.81 435.664L1031.81 434.982L1031.08 434.984L1031.08 435.666L1031.81 435.664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.91 435.67L1029.91 434.988L1029.18 434.99L1029.19 435.672L1029.91 435.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.01 435.675L1028.01 434.994L1027.29 434.996L1027.29 435.678L1028.01 435.675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.12 435.681L1026.11 434.999L1025.39 435.001L1025.39 435.683L1026.12 435.681Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.22 435.687L1024.22 435.005L1023.49 435.007L1023.49 435.689L1024.22 435.687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.32 435.692L1022.32 435.01L1021.6 435.012L1021.6 435.694L1022.32 435.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.42 435.698L1020.42 435.016L1019.7 435.018L1019.7 435.7L1020.42 435.698Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.53 435.704L1018.52 435.022L1017.8 435.024L1017.8 435.706L1018.53 435.704Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.46 437.404L1057.45 436.664L1056.67 436.666L1056.67 437.406L1057.46 437.404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.56 437.409L1055.56 436.669L1054.77 436.672L1054.77 437.412L1055.56 437.409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.66 437.415L1053.66 436.675L1052.87 436.677L1052.88 437.417L1053.66 437.415Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.77 437.42L1051.76 436.68L1050.98 436.683L1050.98 437.423L1051.77 437.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.87 437.426L1049.87 436.686L1049.08 436.688L1049.08 437.428L1049.87 437.426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.97 437.432L1047.97 436.692L1047.18 436.694L1047.18 437.434L1047.97 437.432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.07 437.437L1046.07 436.697L1045.29 436.7L1045.29 437.44L1046.07 437.437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.18 437.443L1044.17 436.703L1043.39 436.705L1043.39 437.445L1044.18 437.443Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.28 437.448L1042.28 436.709L1041.49 436.711L1041.49 437.451L1042.28 437.448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.38 437.454L1040.38 436.714L1039.59 436.716L1039.6 437.456L1040.38 437.454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.48 437.46L1038.48 436.72L1037.7 436.722L1037.7 437.462L1038.48 437.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.59 437.465L1036.58 436.725L1035.8 436.728L1035.8 437.468L1036.59 437.465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.69 437.471L1034.69 436.731L1033.9 436.733L1033.9 437.473L1034.69 437.471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.79 437.476L1032.79 436.737L1032 436.739L1032.01 437.479L1032.79 437.476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.9 437.482L1030.89 436.742L1030.11 436.744L1030.11 437.484L1030.9 437.482Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029 437.488L1029 436.748L1028.21 436.75L1028.21 437.49L1029 437.488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.1 437.493L1027.1 436.753L1026.31 436.756L1026.31 437.496L1027.1 437.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.2 437.499L1025.2 436.759L1024.42 436.761L1024.42 437.501L1025.2 437.499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.31 437.504L1023.3 436.765L1022.52 436.767L1022.52 437.507L1023.31 437.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.41 437.51L1021.41 436.77L1020.62 436.772L1020.62 437.512L1021.41 437.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.51 437.516L1019.51 436.776L1018.72 436.778L1018.73 437.518L1019.51 437.516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.54 439.22L1056.54 438.425L1055.7 438.428L1055.7 439.222L1056.54 439.22Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.65 439.225L1054.64 438.431L1053.8 438.433L1053.8 439.228L1054.65 439.225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.75 439.231L1052.75 438.436L1051.9 438.439L1051.9 439.233L1052.75 439.231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.85 439.237L1050.85 438.442L1050 438.445L1050.01 439.239L1050.85 439.237Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.95 439.242L1048.95 438.448L1048.11 438.45L1048.11 439.245L1048.95 439.242Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.06 439.248L1047.05 438.453L1046.21 438.456L1046.21 439.25L1047.06 439.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.16 439.253L1045.16 438.459L1044.31 438.461L1044.32 439.256L1045.16 439.253Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.26 439.259L1043.26 438.464L1042.42 438.467L1042.42 439.261L1043.26 439.259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.36 439.265L1041.36 438.47L1040.52 438.473L1040.52 439.267L1041.36 439.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.47 439.27L1039.47 438.476L1038.62 438.478L1038.62 439.273L1039.47 439.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.57 439.276L1037.57 438.481L1036.72 438.484L1036.73 439.278L1037.57 439.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.67 439.281L1035.67 438.487L1034.83 438.489L1034.83 439.284L1035.67 439.281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.78 439.287L1033.77 438.492L1032.93 438.495L1032.93 439.289L1033.78 439.287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.88 439.293L1031.88 438.498L1031.03 438.501L1031.03 439.295L1031.88 439.293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.98 439.298L1029.98 438.504L1029.13 438.506L1029.14 439.301L1029.98 439.298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.08 439.304L1028.08 438.509L1027.24 438.512L1027.24 439.306L1028.08 439.304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.19 439.309L1026.18 438.515L1025.34 438.517L1025.34 439.312L1026.19 439.309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.29 439.315L1024.29 438.52L1023.44 438.523L1023.45 439.317L1024.29 439.315Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.39 439.321L1022.39 438.526L1021.55 438.529L1021.55 439.323L1022.39 439.321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.49 439.326L1020.49 438.532L1019.65 438.534L1019.65 439.329L1020.49 439.326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.6 439.332L1018.6 438.537L1017.75 438.54L1017.75 439.334L1018.6 439.332Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.53 441.032L1057.53 440.179L1056.62 440.182L1056.62 441.035L1057.53 441.032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.63 441.037L1055.63 440.185L1054.72 440.188L1054.72 441.04L1055.63 441.037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.73 441.043L1053.73 440.191L1052.82 440.193L1052.83 441.046L1053.73 441.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.84 441.049L1051.83 440.196L1050.93 440.199L1050.93 441.051L1051.84 441.049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.94 441.054L1049.94 440.202L1049.03 440.205L1049.03 441.057L1049.94 441.054Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.04 441.06L1048.04 440.207L1047.13 440.21L1047.14 441.063L1048.04 441.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.14 441.065L1046.14 440.213L1045.24 440.216L1045.24 441.068L1046.14 441.065Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.25 441.071L1044.24 440.219L1043.34 440.221L1043.34 441.074L1044.25 441.071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.35 441.077L1042.35 440.224L1041.44 440.227L1041.44 441.079L1042.35 441.077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.45 441.082L1040.45 440.23L1039.54 440.233L1039.55 441.085L1040.45 441.082Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.55 441.088L1038.55 440.235L1037.65 440.238L1037.65 441.091L1038.55 441.088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.66 441.094L1036.66 440.241L1035.75 440.244L1035.75 441.096L1036.66 441.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.76 441.099L1034.76 440.247L1033.85 440.249L1033.85 441.102L1034.76 441.099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.86 441.105L1032.86 440.252L1031.96 440.255L1031.96 441.107L1032.86 441.105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.97 441.11L1030.96 440.258L1030.06 440.261L1030.06 441.113L1030.97 441.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.07 441.116L1029.07 440.263L1028.16 440.266L1028.16 441.119L1029.07 441.116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.17 441.122L1027.17 440.269L1026.26 440.272L1026.27 441.124L1027.17 441.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.27 441.127L1025.27 440.275L1024.37 440.277L1024.37 441.13L1025.27 441.127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.38 441.133L1023.37 440.28L1022.47 440.283L1022.47 441.135L1023.38 441.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.48 441.138L1021.48 440.286L1020.57 440.289L1020.57 441.141L1021.48 441.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.58 441.144L1019.58 440.291L1018.67 440.294L1018.68 441.147L1019.58 441.144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.62 442.85L1056.61 441.939L1055.65 441.942L1055.65 442.853L1056.62 442.85Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.72 442.855L1054.72 441.945L1053.75 441.948L1053.75 442.858L1054.72 442.855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.82 442.861L1052.82 441.95L1051.85 441.953L1051.85 442.864L1052.82 442.861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.92 442.866L1050.92 441.956L1049.95 441.959L1049.96 442.869L1050.92 442.866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.03 442.872L1049.02 441.962L1048.06 441.965L1048.06 442.875L1049.03 442.872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.13 442.878L1047.13 441.967L1046.16 441.97L1046.16 442.881L1047.13 442.878Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.23 442.883L1045.23 441.973L1044.26 441.976L1044.26 442.886L1045.23 442.883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.33 442.889L1043.33 441.978L1042.36 441.981L1042.37 442.892L1043.33 442.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.44 442.894L1041.43 441.984L1040.47 441.987L1040.47 442.897L1041.44 442.894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.54 442.9L1039.54 441.99L1038.57 441.993L1038.57 442.903L1039.54 442.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.64 442.906L1037.64 441.995L1036.67 441.998L1036.68 442.909L1037.64 442.906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.75 442.911L1035.74 442.001L1034.78 442.004L1034.78 442.914L1035.75 442.911Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.85 442.917L1033.85 442.006L1032.88 442.009L1032.88 442.92L1033.85 442.917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.95 442.923L1031.95 442.012L1030.98 442.015L1030.98 442.925L1031.95 442.923Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.05 442.928L1030.05 442.018L1029.08 442.021L1029.09 442.931L1030.05 442.928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.16 442.934L1028.15 442.023L1027.19 442.026L1027.19 442.937L1028.16 442.934Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.26 442.939L1026.26 442.029L1025.29 442.032L1025.29 442.942L1026.26 442.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.36 442.945L1024.36 442.035L1023.39 442.037L1023.39 442.948L1024.36 442.945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.46 442.951L1022.46 442.04L1021.49 442.043L1021.5 442.953L1022.46 442.951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.57 442.956L1020.56 442.046L1019.6 442.049L1019.6 442.959L1020.57 442.956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.6 444.66L1057.6 443.695L1056.57 443.698L1056.57 444.663L1057.6 444.66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.7 444.666L1055.7 443.701L1054.67 443.704L1054.68 444.669L1055.7 444.666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.8 444.671L1053.8 443.706L1052.78 443.709L1052.78 444.674L1053.8 444.671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.91 444.677L1051.9 443.712L1050.88 443.715L1050.88 444.68L1051.91 444.677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.01 444.683L1050.01 443.718L1048.98 443.721L1048.98 444.686L1050.01 444.683Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.11 444.688L1048.11 443.723L1047.08 443.726L1047.09 444.691L1048.11 444.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.21 444.694L1046.21 443.729L1045.19 443.732L1045.19 444.697L1046.21 444.694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.32 444.699L1044.31 443.734L1043.29 443.737L1043.29 444.702L1044.32 444.699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.42 444.705L1042.42 443.74L1041.39 443.743L1041.39 444.708L1042.42 444.705Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.52 444.711L1040.52 443.746L1039.49 443.749L1039.5 444.714L1040.52 444.711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.63 444.716L1038.62 443.751L1037.6 443.754L1037.6 444.719L1038.63 444.716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.73 444.722L1036.73 443.757L1035.7 443.76L1035.7 444.725L1036.73 444.722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.83 444.727L1034.83 443.762L1033.8 443.765L1033.81 444.73L1034.83 444.727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.93 444.733L1032.93 443.768L1031.91 443.771L1031.91 444.736L1032.93 444.733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.04 444.739L1031.03 443.774L1030.01 443.777L1030.01 444.742L1031.04 444.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.14 444.744L1029.14 443.779L1028.11 443.782L1028.11 444.747L1029.14 444.744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.24 444.75L1027.24 443.785L1026.21 443.788L1026.22 444.753L1027.24 444.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.34 444.755L1025.34 443.79L1024.32 443.793L1024.32 444.758L1025.34 444.755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.45 444.761L1023.44 443.796L1022.42 443.799L1022.42 444.764L1023.45 444.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.55 444.767L1021.55 443.802L1020.52 443.805L1020.52 444.77L1021.55 444.767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.65 444.772L1019.65 443.807L1018.62 443.81L1018.63 444.775L1019.65 444.772Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.69 446.478L1056.68 445.455L1055.6 445.458L1055.6 446.481L1056.69 446.478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.79 446.484L1054.79 445.461L1053.7 445.464L1053.7 446.487L1054.79 446.484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.89 446.489L1052.89 445.466L1051.8 445.469L1051.8 446.492L1052.89 446.489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.99 446.495L1050.99 445.472L1049.9 445.475L1049.91 446.498L1050.99 446.495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.1 446.5L1049.09 445.477L1048.01 445.481L1048.01 446.504L1049.1 446.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.2 446.506L1047.2 445.483L1046.11 445.486L1046.11 446.509L1047.2 446.506Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.3 446.512L1045.3 445.489L1044.21 445.492L1044.22 446.515L1045.3 446.512Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.4 446.517L1043.4 445.494L1042.32 445.497L1042.32 446.52L1043.4 446.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.51 446.523L1041.5 445.5L1040.42 445.503L1040.42 446.526L1041.51 446.523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.61 446.528L1039.61 445.505L1038.52 445.509L1038.52 446.532L1039.61 446.528Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.71 446.534L1037.71 445.511L1036.62 445.514L1036.63 446.537L1037.71 446.534Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.82 446.54L1035.81 445.517L1034.73 445.52L1034.73 446.543L1035.82 446.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.92 446.545L1033.92 445.522L1032.83 445.525L1032.83 446.548L1033.92 446.545Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.02 446.551L1032.02 445.528L1030.93 445.531L1030.93 446.554L1032.02 446.551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.12 446.556L1030.12 445.533L1029.03 445.537L1029.04 446.56L1030.12 446.556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.23 446.562L1028.22 445.539L1027.14 445.542L1027.14 446.565L1028.23 446.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.33 446.568L1026.33 445.545L1025.24 445.548L1025.24 446.571L1026.33 446.568Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.43 446.573L1024.43 445.55L1023.34 445.553L1023.35 446.576L1024.43 446.573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.53 446.579L1022.53 445.556L1021.45 445.559L1021.45 446.582L1022.53 446.579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.64 446.584L1020.63 445.561L1019.55 445.565L1019.55 446.588L1020.64 446.584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.67 448.29L1057.67 447.209L1056.52 447.213L1056.52 448.293L1057.67 448.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.77 448.296L1055.77 447.215L1054.62 447.218L1054.62 448.299L1055.77 448.296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.88 448.301L1053.87 447.22L1052.72 447.224L1052.73 448.305L1053.88 448.301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.98 448.307L1051.98 447.226L1050.83 447.229L1050.83 448.31L1051.98 448.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.08 448.313L1050.08 447.232L1048.93 447.235L1048.93 448.316L1050.08 448.313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.18 448.318L1048.18 447.237L1047.03 447.241L1047.04 448.322L1048.18 448.318Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.29 448.324L1046.28 447.243L1045.14 447.246L1045.14 448.327L1046.29 448.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.39 448.329L1044.39 447.248L1043.24 447.252L1043.24 448.333L1044.39 448.329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.49 448.335L1042.49 447.254L1041.34 447.257L1041.34 448.338L1042.49 448.335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.59 448.341L1040.59 447.26L1039.44 447.263L1039.45 448.344L1040.59 448.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.7 448.346L1038.69 447.265L1037.55 447.269L1037.55 448.35L1038.7 448.346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.8 448.352L1036.8 447.271L1035.65 447.274L1035.65 448.355L1036.8 448.352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.9 448.357L1034.9 447.276L1033.75 447.28L1033.75 448.361L1034.9 448.357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.01 448.363L1033 447.282L1031.85 447.285L1031.86 448.366L1033.01 448.363Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.11 448.369L1031.11 447.288L1029.96 447.291L1029.96 448.372L1031.11 448.369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.21 448.374L1029.21 447.293L1028.06 447.297L1028.06 448.378L1029.21 448.374Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.31 448.38L1027.31 447.299L1026.16 447.302L1026.17 448.383L1027.31 448.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.42 448.385L1025.41 447.304L1024.27 447.308L1024.27 448.389L1025.42 448.385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.52 448.391L1023.52 447.31L1022.37 447.313L1022.37 448.394L1023.52 448.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.62 448.397L1021.62 447.316L1020.47 447.319L1020.47 448.4L1021.62 448.397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.76 450.106L1056.75 448.971L1055.55 448.974L1055.55 450.11L1056.76 450.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.86 450.112L1054.86 448.976L1053.65 448.98L1053.65 450.115L1054.86 450.112Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.96 450.117L1052.96 448.982L1051.75 448.985L1051.76 450.121L1052.96 450.117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.06 450.123L1051.06 448.988L1049.85 448.991L1049.86 450.127L1051.06 450.123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.17 450.129L1049.16 448.993L1047.96 448.997L1047.96 450.132L1049.17 450.129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.27 450.134L1047.27 448.999L1046.06 449.002L1046.06 450.138L1047.27 450.134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.37 450.14L1045.37 449.004L1044.16 449.008L1044.17 450.143L1045.37 450.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.48 450.145L1043.47 449.01L1042.27 449.014L1042.27 450.149L1043.48 450.145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.58 450.151L1041.57 449.016L1040.37 449.019L1040.37 450.155L1041.58 450.151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.68 450.157L1039.68 449.021L1038.47 449.025L1038.47 450.16L1039.68 450.157Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.78 450.162L1037.78 449.027L1036.57 449.03L1036.58 450.166L1037.78 450.162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.89 450.168L1035.88 449.032L1034.68 449.036L1034.68 450.171L1035.89 450.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.99 450.173L1033.99 449.038L1032.78 449.042L1032.78 450.177L1033.99 450.173Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.09 450.179L1032.09 449.044L1030.88 449.047L1030.89 450.183L1032.09 450.179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 450.185L1030.19 449.049L1028.98 449.053L1028.99 450.188L1030.19 450.185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.3 450.19L1028.29 449.055L1027.09 449.058L1027.09 450.194L1028.3 450.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.4 450.196L1026.4 449.06L1025.19 449.064L1025.19 450.199L1026.4 450.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.5 450.201L1024.5 449.066L1023.29 449.07L1023.3 450.205L1024.5 450.201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.61 450.207L1022.6 449.072L1021.4 449.075L1021.4 450.211L1022.61 450.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.74 451.918L1057.74 450.725L1056.47 450.729L1056.47 451.922L1057.74 451.918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.84 451.924L1055.84 450.731L1054.57 450.734L1054.58 451.928L1055.84 451.924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.95 451.93L1053.94 450.736L1052.68 450.74L1052.68 451.933L1053.95 451.93Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.05 451.935L1052.05 450.742L1050.78 450.745L1050.78 451.939L1052.05 451.935Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.15 451.941L1050.15 450.747L1048.88 450.751L1048.88 451.945L1050.15 451.941Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.25 451.946L1048.25 450.753L1046.98 450.757L1046.99 451.95L1048.25 451.946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.36 451.952L1046.35 450.759L1045.09 450.762L1045.09 451.956L1046.36 451.952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.46 451.958L1044.46 450.764L1043.19 450.768L1043.19 451.961L1044.46 451.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.56 451.963L1042.56 450.77L1041.29 450.773L1041.29 451.967L1042.56 451.963Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.67 451.969L1040.66 450.775L1039.39 450.779L1039.4 451.973L1040.67 451.969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.77 451.974L1038.76 450.781L1037.5 450.785L1037.5 451.978L1038.77 451.974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.87 451.98L1036.87 450.787L1035.6 450.79L1035.6 451.984L1036.87 451.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.97 451.986L1034.97 450.792L1033.7 450.796L1033.71 451.989L1034.97 451.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.08 451.991L1033.07 450.798L1031.81 450.802L1031.81 451.995L1033.08 451.991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.18 451.997L1031.18 450.803L1029.91 450.807L1029.91 452.001L1031.18 451.997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.28 452.002L1029.28 450.809L1028.01 450.813L1028.01 452.006L1029.28 452.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.38 452.008L1027.38 450.815L1026.11 450.818L1026.12 452.012L1027.38 452.008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.49 452.014L1025.48 450.82L1024.22 450.824L1024.22 452.017L1025.49 452.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.59 452.019L1023.59 450.826L1022.32 450.83L1022.32 452.023L1023.59 452.019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.83 453.736L1056.82 452.485L1055.5 452.489L1055.5 453.74L1056.83 453.736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.93 453.742L1054.93 452.49L1053.6 452.494L1053.6 453.746L1054.93 453.742Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.03 453.747L1053.03 452.496L1051.7 452.5L1051.7 453.751L1053.03 453.747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.14 453.753L1051.13 452.502L1049.8 452.505L1049.81 453.757L1051.14 453.753Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.24 453.759L1049.24 452.507L1047.91 452.511L1047.91 453.762L1049.24 453.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.34 453.764L1047.34 452.513L1046.01 452.517L1046.01 453.768L1047.34 453.764Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.44 453.77L1045.44 452.518L1044.11 452.522L1044.12 453.774L1045.44 453.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.55 453.775L1043.54 452.524L1042.21 452.528L1042.22 453.779L1043.55 453.775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.65 453.781L1041.65 452.53L1040.32 452.533L1040.32 453.785L1041.65 453.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.75 453.787L1039.75 452.535L1038.42 452.539L1038.42 453.79L1039.75 453.787Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.86 453.792L1037.85 452.541L1036.52 452.545L1036.53 453.796L1037.86 453.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.96 453.798L1035.95 452.546L1034.63 452.55L1034.63 453.802L1035.96 453.798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.06 453.803L1034.06 452.552L1032.73 452.556L1032.73 453.807L1034.06 453.803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.16 453.809L1032.16 452.558L1030.83 452.562L1030.83 453.813L1032.16 453.809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.27 453.815L1030.26 452.563L1028.93 452.567L1028.94 453.819L1030.27 453.815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.37 453.82L1028.37 452.569L1027.04 452.573L1027.04 453.824L1028.37 453.82Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.47 453.826L1026.47 452.574L1025.14 452.578L1025.14 453.83L1026.47 453.826Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.57 453.831L1024.57 452.58L1023.24 452.584L1023.25 453.835L1024.57 453.831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.68 453.837L1022.67 452.586L1021.34 452.59L1021.35 453.841L1022.68 453.837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.81 455.547L1057.81 454.241L1056.42 454.245L1056.42 455.551L1057.81 455.547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.91 455.552L1055.91 454.246L1054.52 454.25L1054.53 455.556L1055.91 455.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.02 455.558L1054.01 454.252L1052.63 454.256L1052.63 455.562L1054.02 455.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.12 455.563L1052.12 454.257L1050.73 454.262L1050.73 455.568L1052.12 455.563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.22 455.569L1050.22 454.263L1048.83 454.267L1048.83 455.573L1050.22 455.569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.32 455.575L1048.32 454.269L1046.93 454.273L1046.94 455.579L1048.32 455.575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.43 455.58L1046.42 454.274L1045.04 454.278L1045.04 455.584L1046.43 455.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.53 455.586L1044.53 454.28L1043.14 454.284L1043.14 455.59L1044.53 455.586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.63 455.591L1042.63 454.285L1041.24 454.29L1041.25 455.596L1042.63 455.591Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.74 455.597L1040.73 454.291L1039.34 454.295L1039.35 455.601L1040.74 455.597Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.84 455.603L1038.83 454.297L1037.45 454.301L1037.45 455.607L1038.84 455.603Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.94 455.608L1036.94 454.302L1035.55 454.306L1035.55 455.612L1036.94 455.608Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.04 455.614L1035.04 454.308L1033.65 454.312L1033.66 455.618L1035.04 455.614Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.15 455.619L1033.14 454.314L1031.76 454.318L1031.76 455.624L1033.15 455.619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.25 455.625L1031.25 454.319L1029.86 454.323L1029.86 455.629L1031.25 455.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.35 455.631L1029.35 454.325L1027.96 454.329L1027.97 455.635L1029.35 455.631Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.46 455.636L1027.45 454.33L1026.06 454.334L1026.07 455.64L1027.46 455.636Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.56 455.642L1025.55 454.336L1024.17 454.34L1024.17 455.646L1025.56 455.642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.66 455.647L1023.66 454.342L1022.27 454.346L1022.27 455.652L1023.66 455.647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.76 455.653L1021.76 454.347L1020.37 454.351L1020.38 455.657L1021.76 455.653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.9 457.364L1056.89 456L1055.45 456.005L1055.45 457.369L1056.9 457.364Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055 457.37L1055 456.006L1053.55 456.01L1053.55 457.374L1055 457.37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.1 457.376L1053.1 456.012L1051.65 456.016L1051.66 457.38L1053.1 457.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.21 457.381L1051.2 456.017L1049.75 456.022L1049.76 457.385L1051.21 457.381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.31 457.387L1049.31 456.023L1047.86 456.027L1047.86 457.391L1049.31 457.387Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.41 457.392L1047.41 456.028L1045.96 456.033L1045.96 457.397L1047.41 457.392Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.52 457.398L1045.51 456.034L1044.06 456.038L1044.07 457.402L1045.52 457.398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.62 457.404L1043.61 456.04L1042.17 456.044L1042.17 457.408L1043.62 457.404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.72 457.409L1041.72 456.045L1040.27 456.05L1040.27 457.414L1041.72 457.409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.82 457.415L1039.82 456.051L1038.37 456.055L1038.37 457.419L1039.82 457.415Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.93 457.42L1037.92 456.057L1036.47 456.061L1036.48 457.425L1037.93 457.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.03 457.426L1036.02 456.062L1034.58 456.066L1034.58 457.43L1036.03 457.426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.13 457.432L1034.13 456.068L1032.68 456.072L1032.68 457.436L1034.13 457.432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.23 457.437L1032.23 456.073L1030.78 456.078L1030.79 457.442L1032.23 457.437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.34 457.443L1030.33 456.079L1028.88 456.083L1028.89 457.447L1030.34 457.443Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.44 457.448L1028.44 456.085L1026.99 456.089L1026.99 457.453L1028.44 457.448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.54 457.454L1026.54 456.09L1025.09 456.094L1025.09 457.458L1026.54 457.454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.65 457.46L1024.64 456.096L1023.19 456.1L1023.2 457.464L1024.65 457.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.75 457.465L1022.74 456.101L1021.3 456.106L1021.3 457.47L1022.75 457.465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_659_491)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 992.971,
    cy: 374.852,
    rx: 9.04902,
    ry: 3.46788,
    fill: "#ED1B2F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_659_491)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 967.452,
    cy: 371.385,
    rx: 4.04765,
    ry: 1.55119,
    fill: "#ED1B2F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1017.85 373.206C1024.29 381.346 1027.37 402.61 1026.95 413.003L1018.23 415.387C1013.61 402.095 1008.63 384.657 1009.44 375.787C1009.31 376.733 1006.35 376.951 1004.57 374.302C1002.92 371.861 1004.57 369.298 1007.06 368.479C1006.15 361.376 1012.9 362.413 1014.19 364.752C1018.99 362.469 1020.48 366.017 1019.83 368.328C1022.29 370.793 1020.77 374.096 1017.85 373.206Z",
    fill: "#FFA896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.95 413.003C1027.37 402.61 1024.29 381.346 1017.85 373.206C1020.77 374.096 1022.29 370.793 1019.83 368.328C1020.48 366.017 1018.99 362.469 1014.19 364.752C1012.9 362.413 1006.15 361.376 1007.06 368.479C1004.57 369.298 1002.92 371.861 1004.57 374.302C1006.35 376.951 1009.31 376.733 1009.44 375.787C1008.63 384.657 1013.61 402.095 1018.23 415.387",
    stroke: "black",
    strokeWidth: 1.12159
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M915.595 402.169V372.324C919.903 373.042 925.202 373.935 930.855 374.9L931.669 398.242L915.595 402.169ZM940.754 396.022L952.411 393.175V378.652C948.398 377.937 944.155 377.193 939.923 376.46L940.754 396.022ZM959.671 391.401L959.096 379.858C968.219 381.524 975.051 382.876 975.875 383.32V387.442L959.671 391.401Z",
    fill: "#FFB434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.855 374.9L931.669 398.242L940.754 396.022L939.923 376.46C936.864 375.93 933.811 375.405 930.855 374.9Z",
    fill: "#F8726E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.411 378.652V393.175L959.671 391.401L959.096 379.858C956.976 379.47 954.732 379.066 952.411 378.652Z",
    fill: "#F8726E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.855 374.9C925.202 373.935 919.903 373.042 915.595 372.324V402.169L931.669 398.242M930.855 374.9L931.669 398.242M930.855 374.9C933.811 375.405 936.864 375.93 939.923 376.46M931.669 398.242L940.754 396.022M939.923 376.46L940.754 396.022M939.923 376.46C944.155 377.193 948.398 377.937 952.411 378.652M940.754 396.022L952.411 393.175M952.411 378.652V393.175M952.411 378.652C954.732 379.066 956.976 379.47 959.096 379.858M952.411 393.175L959.671 391.401M959.096 379.858C968.219 381.524 975.051 382.876 975.875 383.32V387.442L959.671 391.401M959.096 379.858L959.671 391.401",
    stroke: "black",
    strokeWidth: 1.08141
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_659_491)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.389 374.508C423.225 374.221 420.889 373.194 420.857 371.386C420.815 369.127 426.527 367.854 428.046 369.949C429.565 372.044 427.922 374.056 424.389 374.508ZM427.133 369.977C427.553 370.538 427.913 371.645 425.996 371.579C423.601 371.497 424.997 368.827 427.133 369.977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.133 369.977C427.553 370.538 427.913 371.645 425.996 371.579C423.601 371.497 424.997 368.827 427.133 369.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.467 328.09C383.467 328.09 390.507 335.157 394.258 340.401C399.229 339.483 405.607 339.122 411.47 340.692C414.517 337.395 425.422 331.736 425.422 331.736C425.422 331.736 426.302 342.683 424.335 347.69C428.101 351.34 430.845 356.357 431.705 363.054C431.859 364.255 431.953 365.511 431.981 366.821C433.82 372.031 434.727 383.168 425.922 390.452C428.812 391.966 437.792 370.13 442.459 374.508C448.293 379.981 448.86 380.647 439.084 391.541C425.922 397.217 421.584 407.038 421.471 408.037C426.049 449.136 379.814 493.798 367.125 493.656C361.234 493.59 353.777 489.401 347.766 481.455C346.319 481.745 344.317 481.951 342.14 482.174C336.042 482.801 328.57 483.569 328.071 486.72C327.333 491.382 331.569 491.754 336.067 492.149C340.855 492.57 345.941 493.017 345.643 498.692C345.064 509.698 318.61 506.802 314.748 490.389C311.659 477.259 331.291 471.504 341.493 470.268C337.581 460.588 335.764 448.041 338.172 432.886C343.118 401.761 360.641 382.118 368.784 376.186C366.974 360.624 373.147 351.914 376.459 349.504C376.706 340.935 383.467 328.09 383.467 328.09ZM420.857 371.386C420.889 373.194 423.225 374.221 424.389 374.508C427.922 374.056 429.565 372.044 428.046 369.949C426.527 367.854 420.815 369.127 420.857 371.386ZM428.046 383.16C426.861 382.734 425.25 381.209 424.257 380.094C422.995 382.132 421.051 384.529 419.047 385.625C419.349 386.397 419.659 387.04 419.975 387.566C421.376 390.259 424.583 389.322 426.341 386.558C427.033 385.47 427.62 384.243 428.046 383.16Z",
    fill: "url(#paint1_linear_659_491)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.046 383.16C426.861 382.734 425.25 381.209 424.257 380.094C422.995 382.132 421.051 384.529 419.047 385.625C419.349 386.397 419.659 387.04 419.975 387.566C421.757 385.257 424.961 385.932 426.341 386.558C427.033 385.47 427.62 384.243 428.046 383.16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.341 386.558C424.583 389.322 421.376 390.259 419.975 387.566C421.757 385.257 424.961 385.932 426.341 386.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.583 392.906C397.539 395.775 408.737 399.792 421.883 392.906C423.445 392.088 424.735 391.435 425.922 390.452M380.672 387.298C378.934 386.385 374.986 383.777 373.109 380.647M396.322 343.48C394.366 338.698 383.467 328.09 383.467 328.09M383.467 328.09C383.467 328.09 376.706 340.935 376.459 349.504M383.467 328.09C383.467 328.09 390.507 335.157 394.258 340.401C399.229 339.483 405.607 339.122 411.47 340.692M376.499 351.173C376.502 350.57 376.439 350.183 376.459 349.504M411.47 340.692C414.517 337.395 425.422 331.736 425.422 331.736C425.422 331.736 426.302 342.683 424.335 347.69M411.47 340.692C414.455 341.491 417.443 342.422 420.093 344.072M424.335 347.69C423.01 346.406 421.633 345.032 420.093 344.072M424.335 347.69C428.101 351.34 430.845 356.357 431.705 363.054M423.198 338.084L420.093 344.072M385.419 335.283C386.424 336.001 391.38 341.864 389.513 342.968C388.019 343.852 384.533 345.587 382.977 346.344M376.459 349.504C373.147 351.914 366.974 360.624 368.784 376.186C360.641 382.118 343.118 401.761 338.172 432.886C335.764 448.041 337.581 460.588 341.493 470.268M420.093 400.205C420.784 402.708 421.188 405.495 421.471 408.037M425.922 390.452C434.727 383.168 433.82 372.031 431.981 366.821C431.953 365.511 431.859 364.255 431.705 363.054M425.922 390.452C428.812 391.966 437.792 370.13 442.459 374.508C448.293 379.981 448.86 380.647 439.084 391.541C425.922 397.217 421.584 407.038 421.471 408.037M421.471 408.037C426.049 449.136 379.814 493.798 367.125 493.656C361.234 493.59 353.777 489.401 347.766 481.455M341.493 470.268C331.291 471.504 311.659 477.259 314.748 490.389C318.61 506.802 345.064 509.698 345.643 498.692C345.942 493.017 340.855 492.57 336.067 492.149C331.569 491.754 327.333 491.382 328.071 486.72C328.57 483.569 336.042 482.801 342.14 482.174C344.317 481.951 346.319 481.745 347.766 481.455M341.493 470.268C343.232 474.571 345.386 478.308 347.766 481.455M431.705 363.054C430.916 363.329 429.155 364.086 428.12 365.949M411.544 365.949C410.969 364.105 402.106 360.964 397.792 367.474M424.389 374.508L424.257 380.094M424.389 374.508C423.225 374.221 420.889 373.194 420.857 371.386C420.815 369.127 426.527 367.854 428.046 369.949C429.565 372.044 427.922 374.056 424.389 374.508ZM424.257 380.094C425.25 381.209 426.861 382.734 428.046 383.16M424.257 380.094C422.995 382.132 421.051 384.529 419.047 385.625M412.471 379.835C413.931 386.052 416.5 387.019 419.047 385.625M428.12 377.733C428.723 377.908 429.865 378.974 429.613 381.834C429.512 382.979 428.837 383.444 428.046 383.16M428.046 383.16C427.62 384.243 427.033 385.47 426.341 386.558M419.047 385.625C419.349 386.397 419.659 387.04 419.975 387.566M426.341 386.558C424.583 389.322 421.376 390.259 419.975 387.566M426.341 386.558C424.961 385.932 421.757 385.257 419.975 387.566M427.133 369.977C427.553 370.538 427.913 371.645 425.996 371.579C423.601 371.497 424.997 368.827 427.133 369.977Z",
    stroke: "black",
    strokeWidth: 1.12159
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.906 389.342C457.041 395.519 430.305 390.097 422.581 388.552C421.548 385.554 421.897 383.458 423.765 381.65L454.732 385.638C450.546 383.057 450.699 375.037 458.384 375.34C465.879 375.635 469.92 383.931 463.906 389.342Z",
    fill: "#82B1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.609 381.651C459.469 376.72 464.85 384.125 460.258 385.891C458.012 386.755 456.13 386.5 454.732 385.638M454.732 385.638C450.546 383.057 450.699 375.037 458.384 375.34C465.879 375.635 469.92 383.931 463.906 389.342C457.041 395.519 430.305 390.097 422.581 388.552C421.548 385.554 421.897 383.458 423.765 381.65L454.732 385.638Z",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.552 421.206L384.553 420.978L384.796 420.978L384.795 421.207L384.552 421.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.45 421.212L386.45 420.983L386.693 420.984L386.692 421.212L386.45 421.212Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.347 421.217L388.347 420.989L388.59 420.99L388.589 421.218L388.347 421.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.244 421.223L390.245 420.994L390.487 420.995L390.487 421.224L390.244 421.223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.141 421.228L392.142 421L392.385 421.001L392.384 421.229L392.141 421.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.039 421.234L394.039 421.006L394.282 421.006L394.281 421.235L394.039 421.234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.936 421.24L395.937 421.011L396.179 421.012L396.179 421.24L395.936 421.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.833 421.245L397.834 421.017L398.076 421.018L398.076 421.246L397.833 421.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.73 421.251L399.731 421.022L399.974 421.023L399.973 421.252L399.73 421.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.628 421.256L401.628 421.028L401.871 421.029L401.87 421.257L401.628 421.256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.525 421.262L403.526 421.034L403.768 421.034L403.768 421.263L403.525 421.262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.422 421.268L405.423 421.039L405.666 421.04L405.665 421.268L405.422 421.268Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.319 421.273L407.32 421.045L407.563 421.046L407.562 421.274L407.319 421.273Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.217 421.279L409.217 421.05L409.46 421.051L409.459 421.28L409.217 421.279Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.114 421.285L411.115 421.056L411.357 421.057L411.357 421.285L411.114 421.285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.011 421.29L413.012 421.062L413.255 421.062L413.254 421.291L413.011 421.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.909 421.296L414.909 421.067L415.152 421.068L415.151 421.296L414.909 421.296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.806 421.301L416.806 421.073L417.049 421.074L417.048 421.302L416.806 421.301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.703 421.307L418.704 421.078L418.946 421.079L418.946 421.308L418.703 421.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.569 423.017L383.57 422.734L383.871 422.734L383.87 423.017L383.569 423.017Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.467 423.022L385.467 422.739L385.768 422.74L385.767 423.023L385.467 423.022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.364 423.028L387.365 422.745L387.665 422.746L387.664 423.029L387.364 423.028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.261 423.033L389.262 422.75L389.563 422.751L389.562 423.034L389.261 423.033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.158 423.039L391.159 422.756L391.46 422.757L391.459 423.04L391.158 423.039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.056 423.045L393.056 422.762L393.357 422.762L393.356 423.045L393.056 423.045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.953 423.05L394.954 422.767L395.254 422.768L395.254 423.051L394.953 423.05Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.85 423.056L396.851 422.773L397.152 422.774L397.151 423.057L396.85 423.056Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.747 423.061L398.748 422.778L399.049 422.779L399.048 423.062L398.747 423.061Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.645 423.067L400.646 422.784L400.946 422.785L400.945 423.068L400.645 423.067Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.542 423.073L402.543 422.79L402.843 422.79L402.843 423.073L402.542 423.073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.439 423.078L404.44 422.795L404.741 422.796L404.74 423.079L404.439 423.078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.337 423.084L406.337 422.801L406.638 422.802L406.637 423.085L406.337 423.084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.234 423.089L408.235 422.806L408.535 422.807L408.534 423.09L408.234 423.089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.131 423.095L410.132 422.812L410.433 422.813L410.432 423.096L410.131 423.095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.028 423.101L412.029 422.818L412.33 422.818L412.329 423.101L412.028 423.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.926 423.106L413.926 422.823L414.227 422.824L414.226 423.107L413.926 423.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.823 423.112L415.824 422.829L416.124 422.83L416.123 423.113L415.823 423.112Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.72 423.117L417.721 422.834L418.022 422.835L418.021 423.118L417.72 423.117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.585 424.829L382.586 424.488L382.948 424.489L382.947 424.83L382.585 424.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.482 424.834L384.483 424.493L384.845 424.494L384.844 424.835L384.482 424.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.379 424.84L386.38 424.499L386.742 424.5L386.741 424.841L386.379 424.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.276 424.846L388.277 424.505L388.64 424.506L388.639 424.847L388.276 424.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.174 424.851L390.175 424.51L390.537 424.511L390.536 424.852L390.174 424.851Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.071 424.857L392.072 424.516L392.434 424.517L392.433 424.858L392.071 424.857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.968 424.862L393.969 424.521L394.331 424.522L394.33 424.863L393.968 424.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.865 424.868L395.866 424.527L396.229 424.528L396.228 424.869L395.865 424.868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.763 424.874L397.764 424.533L398.126 424.534L398.125 424.875L397.763 424.874Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.66 424.879L399.661 424.538L400.023 424.539L400.022 424.88L399.66 424.879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.557 424.885L401.558 424.544L401.92 424.545L401.919 424.886L401.557 424.885Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.454 424.89L403.455 424.549L403.818 424.55L403.817 424.891L403.454 424.89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.352 424.896L405.353 424.555L405.715 424.556L405.714 424.897L405.352 424.896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.249 424.902L407.25 424.561L407.612 424.562L407.611 424.903L407.249 424.902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.146 424.907L409.147 424.566L409.509 424.567L409.508 424.908L409.146 424.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.044 424.913L411.045 424.572L411.407 424.573L411.406 424.914L411.044 424.913Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.941 424.918L412.942 424.577L413.304 424.578L413.303 424.919L412.941 424.918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.838 424.924L414.839 424.583L415.201 424.584L415.2 424.925L414.838 424.924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.735 424.93L416.736 424.589L417.099 424.59L417.098 424.931L416.735 424.93Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.633 424.935L418.634 424.594L418.996 424.595L418.995 424.936L418.633 424.935Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.6 426.641L381.601 426.242L382.025 426.243L382.024 426.642L381.6 426.641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.497 426.647L383.498 426.248L383.922 426.249L383.921 426.648L383.497 426.647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.394 426.652L385.395 426.253L385.819 426.254L385.818 426.653L385.394 426.652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.292 426.658L387.293 426.259L387.717 426.26L387.715 426.659L387.292 426.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.189 426.663L389.19 426.264L389.614 426.266L389.613 426.665L389.189 426.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.086 426.669L391.087 426.27L391.511 426.271L391.51 426.67L391.086 426.669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.983 426.675L392.985 426.276L393.408 426.277L393.407 426.676L392.983 426.675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.881 426.68L394.882 426.281L395.306 426.282L395.304 426.681L394.881 426.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.778 426.686L396.779 426.287L397.203 426.288L397.202 426.687L396.778 426.686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.675 426.691L398.676 426.292L399.1 426.294L399.099 426.693L398.675 426.691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.572 426.697L400.574 426.298L400.997 426.299L400.996 426.698L400.572 426.697Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.47 426.703L402.471 426.304L402.895 426.305L402.893 426.704L402.47 426.703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.367 426.708L404.368 426.309L404.792 426.31L404.791 426.709L404.367 426.708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.264 426.714L406.265 426.315L406.689 426.316L406.688 426.715L406.264 426.714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.161 426.719L408.163 426.32L408.586 426.322L408.585 426.721L408.161 426.719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.059 426.725L410.06 426.326L410.484 426.327L410.483 426.726L410.059 426.725Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.956 426.731L411.957 426.332L412.381 426.333L412.38 426.732L411.956 426.731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.853 426.736L413.854 426.337L414.278 426.338L414.277 426.737L413.853 426.736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.751 426.742L415.752 426.343L416.176 426.344L416.174 426.743L415.751 426.742Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.648 426.747L417.649 426.348L418.073 426.35L418.072 426.749L417.648 426.747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.617 428.451L380.618 427.998L381.1 427.999L381.099 428.453L380.617 428.451Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.514 428.457L382.515 428.003L382.997 428.005L382.996 428.458L382.514 428.457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.411 428.463L384.413 428.009L384.894 428.011L384.893 428.464L384.411 428.463Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.309 428.468L386.31 428.015L386.792 428.016L386.79 428.47L386.309 428.468Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.206 428.474L388.207 428.02L388.689 428.022L388.688 428.475L388.206 428.474Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.103 428.479L390.104 428.026L390.586 428.027L390.585 428.481L390.103 428.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 428.485L392.002 428.031L392.483 428.033L392.482 428.486L392 428.485Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.898 428.491L393.899 428.037L394.381 428.039L394.379 428.492L393.898 428.491Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.795 428.496L395.796 428.043L396.278 428.044L396.277 428.498L395.795 428.496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.692 428.502L397.694 428.048L398.175 428.05L398.174 428.503L397.692 428.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.589 428.507L399.591 428.054L400.073 428.055L400.071 428.509L399.589 428.507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.487 428.513L401.488 428.06L401.97 428.061L401.968 428.514L401.487 428.513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.384 428.519L403.385 428.065L403.867 428.067L403.866 428.52L403.384 428.519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.281 428.524L405.283 428.071L405.764 428.072L405.763 428.526L405.281 428.524Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.179 428.53L407.18 428.076L407.662 428.078L407.66 428.531L407.179 428.53Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.076 428.535L409.077 428.082L409.559 428.083L409.558 428.537L409.076 428.535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.973 428.541L410.974 428.088L411.456 428.089L411.455 428.542L410.973 428.541Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.87 428.547L412.872 428.093L413.353 428.095L413.352 428.548L412.87 428.547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.768 428.552L414.769 428.099L415.251 428.1L415.249 428.554L414.768 428.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.665 428.558L416.666 428.104L417.148 428.106L417.147 428.559L416.665 428.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.562 428.563L418.563 428.11L419.045 428.111L419.044 428.565L418.562 428.563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.632 430.264L379.633 429.752L380.177 429.754L380.175 430.265L379.632 430.264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.529 430.269L381.531 429.758L382.074 429.759L382.073 430.271L381.529 430.269Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.427 430.275L383.428 429.763L383.971 429.765L383.97 430.276L383.427 430.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.324 430.28L385.325 429.769L385.869 429.771L385.867 430.282L385.324 430.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.221 430.286L387.223 429.775L387.766 429.776L387.764 430.288L387.221 430.286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.118 430.292L389.12 429.78L389.663 429.782L389.662 430.293L389.118 430.292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.016 430.297L391.017 429.786L391.56 429.787L391.559 430.299L391.016 430.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.913 430.303L392.914 429.791L393.458 429.793L393.456 430.304L392.913 430.303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.81 430.308L394.812 429.797L395.355 429.799L395.353 430.31L394.81 430.308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.707 430.314L396.709 429.803L397.252 429.804L397.251 430.316L396.707 430.314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.605 430.32L398.606 429.808L399.149 429.81L399.148 430.321L398.605 430.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.502 430.325L400.503 429.814L401.047 429.815L401.045 430.327L400.502 430.325Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.399 430.331L402.401 429.819L402.944 429.821L402.943 430.332L402.399 430.331Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.296 430.336L404.298 429.825L404.841 429.827L404.84 430.338L404.296 430.336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.194 430.342L406.195 429.831L406.739 429.832L406.737 430.344L406.194 430.342Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.091 430.348L408.093 429.836L408.636 429.838L408.634 430.349L408.091 430.348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.988 430.353L409.99 429.842L410.533 429.843L410.532 430.355L409.988 430.353Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.886 430.359L411.887 429.847L412.43 429.849L412.429 430.36L411.886 430.359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.783 430.364L413.784 429.853L414.328 429.855L414.326 430.366L413.783 430.364Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.68 430.37L415.682 429.859L416.225 429.86L416.223 430.372L415.68 430.37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.577 430.376L417.579 429.864L418.122 429.866L418.121 430.377L417.577 430.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.544 432.081L380.546 431.512L381.151 431.514L381.149 432.083L380.544 432.081Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.442 432.087L382.443 431.518L383.048 431.519L383.047 432.089L382.442 432.087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.339 432.093L384.341 431.523L384.946 431.525L384.944 432.094L384.339 432.093Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.236 432.098L386.238 431.529L386.843 431.53L386.841 432.1L386.236 432.098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.134 432.104L388.135 431.534L388.74 431.536L388.738 432.106L388.134 432.104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.031 432.109L390.032 431.54L390.637 431.542L390.636 432.111L390.031 432.109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.928 432.115L391.93 431.546L392.535 431.547L392.533 432.117L391.928 432.115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.825 432.121L393.827 431.551L394.432 431.553L394.43 432.122L393.825 432.121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.723 432.126L395.724 431.557L396.329 431.559L396.327 432.128L395.723 432.126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.62 432.132L397.622 431.562L398.226 431.564L398.225 432.134L397.62 432.132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.517 432.137L399.519 431.568L400.124 431.57L400.122 432.139L399.517 432.137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.414 432.143L401.416 431.574L402.021 431.575L402.019 432.145L401.414 432.143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.312 432.149L403.313 431.579L403.918 431.581L403.917 432.15L403.312 432.149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.209 432.154L405.211 431.585L405.816 431.587L405.814 432.156L405.209 432.154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.106 432.16L407.108 431.59L407.713 431.592L407.711 432.162L407.106 432.16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.003 432.165L409.005 431.596L409.61 431.598L409.608 432.167L409.003 432.165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.901 432.171L410.902 431.602L411.507 431.603L411.506 432.173L410.901 432.171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.798 432.177L412.8 431.607L413.405 431.609L413.403 432.178L412.798 432.177Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.695 432.182L414.697 431.613L415.302 431.615L415.3 432.184L414.695 432.182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.593 432.188L416.594 431.618L417.199 431.62L417.197 432.19L416.593 432.188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.49 432.193L418.492 431.624L419.096 431.626L419.095 432.195L418.49 432.193Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.562 433.892L379.563 433.268L380.226 433.27L380.224 433.894L379.562 433.892Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.459 433.897L381.461 433.273L382.123 433.275L382.122 433.899L381.459 433.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.356 433.903L383.358 433.279L384.021 433.281L384.019 433.905L383.356 433.903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.253 433.909L385.255 433.285L385.918 433.287L385.916 433.911L385.253 433.909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.151 433.914L387.152 433.29L387.815 433.292L387.813 433.916L387.151 433.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.048 433.92L389.05 433.296L389.713 433.298L389.711 433.922L389.048 433.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.945 433.925L390.947 433.301L391.61 433.303L391.608 433.927L390.945 433.925Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.842 433.931L392.844 433.307L393.507 433.309L393.505 433.933L392.842 433.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.74 433.937L394.741 433.313L395.404 433.315L395.402 433.939L394.74 433.937Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.637 433.942L396.639 433.318L397.302 433.32L397.3 433.944L396.637 433.942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.534 433.948L398.536 433.324L399.199 433.326L399.197 433.95L398.534 433.948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.431 433.953L400.433 433.329L401.096 433.331L401.094 433.955L400.431 433.953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.329 433.959L402.331 433.335L402.993 433.337L402.992 433.961L402.329 433.959Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.226 433.965L404.228 433.341L404.891 433.343L404.889 433.967L404.226 433.965Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.123 433.97L406.125 433.346L406.788 433.348L406.786 433.972L406.123 433.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.021 433.976L408.022 433.352L408.685 433.354L408.683 433.978L408.021 433.976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.918 433.981L409.92 433.357L410.582 433.359L410.581 433.983L409.918 433.981Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.815 433.987L411.817 433.363L412.48 433.365L412.478 433.989L411.815 433.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.712 433.993L413.714 433.369L414.377 433.371L414.375 433.995L413.712 433.993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.61 433.998L415.611 433.374L416.274 433.376L416.272 434L415.61 433.998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.507 434.004L417.509 433.38L418.172 433.382L418.17 434.006L417.507 434.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.474 435.71L380.476 435.028L381.2 435.03L381.198 435.712L380.474 435.71Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.371 435.715L382.373 435.033L383.098 435.035L383.096 435.717L382.371 435.715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.269 435.721L384.271 435.039L384.995 435.041L384.993 435.723L384.269 435.721Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.166 435.726L386.168 435.044L386.892 435.047L386.89 435.729L386.166 435.726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.063 435.732L388.065 435.05L388.789 435.052L388.787 435.734L388.063 435.732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.96 435.738L389.962 435.056L390.687 435.058L390.685 435.74L389.96 435.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.858 435.743L391.86 435.061L392.584 435.063L392.582 435.745L391.858 435.743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.755 435.749L393.757 435.067L394.481 435.069L394.479 435.751L393.755 435.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.652 435.754L395.654 435.072L396.379 435.075L396.377 435.757L395.652 435.754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.549 435.76L397.551 435.078L398.276 435.08L398.274 435.762L397.549 435.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.447 435.766L399.449 435.084L400.173 435.086L400.171 435.768L399.447 435.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.344 435.771L401.346 435.089L402.07 435.091L402.068 435.773L401.344 435.771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.241 435.777L403.243 435.095L403.968 435.097L403.966 435.779L403.241 435.777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.138 435.782L405.14 435.1L405.865 435.103L405.863 435.785L405.138 435.782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.036 435.788L407.038 435.106L407.762 435.108L407.76 435.79L407.036 435.788Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.933 435.794L408.935 435.112L409.659 435.114L409.657 435.796L408.933 435.794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.83 435.799L410.832 435.117L411.557 435.119L411.555 435.801L410.83 435.799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.728 435.805L412.73 435.123L413.454 435.125L413.452 435.807L412.728 435.805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.625 435.81L414.627 435.129L415.351 435.131L415.349 435.813L414.625 435.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.522 435.816L416.524 435.134L417.249 435.136L417.246 435.818L416.522 435.816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.419 435.822L418.421 435.14L419.146 435.142L419.144 435.824L418.419 435.822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.489 437.522L379.491 436.782L380.277 436.784L380.275 437.524L379.489 437.522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.386 437.527L381.389 436.787L382.175 436.79L382.172 437.53L381.386 437.527Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.284 437.533L383.286 436.793L384.072 436.795L384.07 437.535L383.284 437.533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.181 437.539L385.183 436.799L385.969 436.801L385.967 437.541L385.181 437.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.078 437.544L387.08 436.804L387.866 436.807L387.864 437.547L387.078 437.544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.976 437.55L388.978 436.81L389.764 436.812L389.762 437.552L388.976 437.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.873 437.555L390.875 436.815L391.661 436.818L391.659 437.558L390.873 437.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.77 437.561L392.772 436.821L393.558 436.823L393.556 437.563L392.77 437.561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.667 437.567L394.67 436.827L395.456 436.829L395.453 437.569L394.667 437.567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.565 437.572L396.567 436.832L397.353 436.835L397.351 437.575L396.565 437.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.462 437.578L398.464 436.838L399.25 436.84L399.248 437.58L398.462 437.578Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.359 437.583L400.361 436.843L401.147 436.846L401.145 437.586L400.359 437.583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.256 437.589L402.259 436.849L403.045 436.851L403.042 437.591L402.256 437.589Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.154 437.595L404.156 436.855L404.942 436.857L404.94 437.597L404.154 437.595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.051 437.6L406.053 436.86L406.839 436.863L406.837 437.603L406.051 437.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.948 437.606L407.95 436.866L408.736 436.868L408.734 437.608L407.948 437.606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.845 437.611L409.848 436.872L410.634 436.874L410.631 437.614L409.845 437.611Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.743 437.617L411.745 436.877L412.531 436.879L412.529 437.619L411.743 437.617Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.64 437.623L413.642 436.883L414.428 436.885L414.426 437.625L413.64 437.623Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.537 437.628L415.539 436.888L416.325 436.891L416.323 437.631L415.537 437.628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.435 437.634L417.437 436.894L418.223 436.896L418.221 437.636L417.435 437.634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.404 439.338L380.406 438.543L381.25 438.546L381.247 439.34L380.404 439.338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.301 439.343L382.303 438.549L383.147 438.551L383.145 439.346L382.301 439.343Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.198 439.349L384.2 438.555L385.044 438.557L385.042 439.352L384.198 439.349Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.095 439.355L386.098 438.56L386.942 438.563L386.939 439.357L386.095 439.355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.993 439.36L387.995 438.566L388.839 438.568L388.837 439.363L387.993 439.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.89 439.366L389.892 438.571L390.736 438.574L390.734 439.368L389.89 439.366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.787 439.371L391.789 438.577L392.633 438.579L392.631 439.374L391.787 439.371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.684 439.377L393.687 438.583L394.531 438.585L394.528 439.38L393.684 439.377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.582 439.383L395.584 438.588L396.428 438.591L396.426 439.385L395.582 439.383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.479 439.388L397.481 438.594L398.325 438.596L398.323 439.391L397.479 439.388Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.376 439.394L399.379 438.599L400.222 438.602L400.22 439.396L399.376 439.394Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.273 439.4L401.276 438.605L402.12 438.608L402.117 439.402L401.273 439.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.171 439.405L403.173 438.611L404.017 438.613L404.015 439.408L403.171 439.405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.068 439.411L405.07 438.616L405.914 438.619L405.912 439.413L405.068 439.411Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.965 439.416L406.968 438.622L407.812 438.624L407.809 439.419L406.965 439.416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.863 439.422L408.865 438.627L409.709 438.63L409.706 439.424L408.863 439.422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.76 439.428L410.762 438.633L411.606 438.636L411.604 439.43L410.76 439.428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.657 439.433L412.659 438.639L413.503 438.641L413.501 439.436L412.657 439.433Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.554 439.439L414.557 438.644L415.401 438.647L415.398 439.441L414.554 439.439Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.452 439.444L416.454 438.65L417.298 438.652L417.296 439.447L416.452 439.444Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.349 439.45L418.351 438.655L419.195 438.658L419.193 439.452L418.349 439.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.419 441.15L379.421 440.298L380.327 440.3L380.324 441.153L379.419 441.15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.316 441.156L381.319 440.303L382.224 440.306L382.222 441.158L381.316 441.156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.213 441.161L383.216 440.309L384.121 440.311L384.119 441.164L383.213 441.161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.111 441.167L385.113 440.314L386.019 440.317L386.016 441.17L385.111 441.167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.008 441.172L387.01 440.32L387.916 440.323L387.913 441.175L387.008 441.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.905 441.178L388.908 440.326L389.813 440.328L389.811 441.181L388.905 441.178Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.802 441.184L390.805 440.331L391.71 440.334L391.708 441.186L390.802 441.184Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.7 441.189L392.702 440.337L393.608 440.339L393.605 441.192L392.7 441.189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.597 441.195L394.599 440.342L395.505 440.345L395.502 441.198L394.597 441.195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.494 441.2L396.497 440.348L397.402 440.351L397.4 441.203L396.494 441.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.391 441.206L398.394 440.354L399.299 440.356L399.297 441.209L398.391 441.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.289 441.212L400.291 440.359L401.197 440.362L401.194 441.214L400.289 441.212Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.186 441.217L402.188 440.365L403.094 440.368L403.091 441.22L402.186 441.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.083 441.223L404.086 440.37L404.991 440.373L404.989 441.226L404.083 441.223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.98 441.228L405.983 440.376L406.889 440.379L406.886 441.231L405.98 441.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.878 441.234L407.88 440.382L408.786 440.384L408.783 441.237L407.878 441.234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.775 441.24L409.778 440.387L410.683 440.39L410.681 441.242L409.775 441.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.672 441.245L411.675 440.393L412.58 440.396L412.578 441.248L411.672 441.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.57 441.251L413.572 440.398L414.478 440.401L414.475 441.254L413.57 441.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.467 441.257L415.469 440.404L416.375 440.407L416.372 441.259L415.467 441.257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.364 441.262L417.367 440.41L418.272 440.412L418.27 441.265L417.364 441.262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.331 442.968L380.334 442.057L381.301 442.06L381.298 442.971L380.331 442.968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.228 442.973L382.231 442.063L383.198 442.066L383.196 442.976L382.228 442.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.126 442.979L384.128 442.069L385.096 442.071L385.093 442.982L384.126 442.979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.023 442.985L386.026 442.074L386.993 442.077L386.99 442.987L386.023 442.985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.92 442.99L387.923 442.08L388.89 442.083L388.887 442.993L387.92 442.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.818 442.996L389.82 442.085L390.787 442.088L390.785 442.999L389.818 442.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.715 443.001L391.718 442.091L392.685 442.094L392.682 443.004L391.715 443.001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.612 443.007L393.615 442.097L394.582 442.099L394.579 443.01L393.612 443.007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.509 443.013L395.512 442.102L396.479 442.105L396.476 443.016L395.509 443.013Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.407 443.018L397.409 442.108L398.376 442.111L398.374 443.021L397.407 443.018Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.304 443.024L399.307 442.113L400.274 442.116L400.271 443.027L399.304 443.024Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.201 443.029L401.204 442.119L402.171 442.122L402.168 443.032L401.201 443.029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.098 443.035L403.101 442.125L404.068 442.128L404.066 443.038L403.098 443.035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.996 443.041L404.998 442.13L405.965 442.133L405.963 443.044L404.996 443.041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.893 443.046L406.896 442.136L407.863 442.139L407.86 443.049L406.893 443.046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.79 443.052L408.793 442.141L409.76 442.144L409.757 443.055L408.79 443.052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.687 443.057L410.69 442.147L411.657 442.15L411.655 443.06L410.687 443.057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.585 443.063L412.587 442.153L413.555 442.156L413.552 443.066L412.585 443.063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.482 443.069L414.485 442.158L415.452 442.161L415.449 443.072L414.482 443.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.379 443.074L416.382 442.164L417.349 442.167L417.346 443.077L416.379 443.074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.348 444.778L379.351 443.813L380.376 443.816L380.373 444.781L379.348 444.778Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.246 444.784L381.248 443.819L382.273 443.822L382.271 444.787L381.246 444.784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.143 444.79L383.146 443.825L384.171 443.828L384.168 444.793L383.143 444.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.04 444.795L385.043 443.83L386.068 443.833L386.065 444.798L385.04 444.795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.937 444.801L386.94 443.836L387.965 443.839L387.962 444.804L386.937 444.801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.835 444.806L388.837 443.841L389.862 443.844L389.86 444.809L388.835 444.806Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.732 444.812L390.735 443.847L391.76 443.85L391.757 444.815L390.732 444.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.629 444.818L392.632 443.853L393.657 443.856L393.654 444.821L392.629 444.818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.526 444.823L394.529 443.858L395.554 443.861L395.551 444.826L394.526 444.823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.424 444.829L396.427 443.864L397.452 443.867L397.449 444.832L396.424 444.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.321 444.834L398.324 443.869L399.349 443.872L399.346 444.837L398.321 444.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.218 444.84L400.221 443.875L401.246 443.878L401.243 444.843L400.218 444.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.115 444.846L402.118 443.881L403.143 443.884L403.141 444.849L402.115 444.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.013 444.851L404.016 443.886L405.041 443.889L405.038 444.854L404.013 444.851Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.91 444.857L405.913 443.892L406.938 443.895L406.935 444.86L405.91 444.857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.807 444.862L407.81 443.897L408.835 443.9L408.832 444.865L407.807 444.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.705 444.868L409.707 443.903L410.732 443.906L410.73 444.871L409.705 444.868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.602 444.874L411.605 443.909L412.63 443.912L412.627 444.877L411.602 444.874Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.499 444.879L413.502 443.914L414.527 443.917L414.524 444.882L413.499 444.879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.396 444.885L415.399 443.92L416.424 443.923L416.421 444.888L415.396 444.885Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.294 444.89L417.296 443.925L418.321 443.928L418.319 444.893L417.294 444.89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.261 446.596L380.264 445.573L381.35 445.576L381.347 446.599L380.261 446.596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.158 446.602L382.161 445.579L383.248 445.582L383.245 446.605L382.158 446.602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.055 446.607L384.058 445.584L385.145 445.588L385.142 446.61L384.055 446.607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.953 446.613L385.956 445.59L387.042 445.593L387.039 446.616L385.953 446.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.85 446.618L387.853 445.596L388.939 445.599L388.936 446.622L387.85 446.618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.747 446.624L389.75 445.601L390.837 445.604L390.834 446.627L389.747 446.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.644 446.63L391.647 445.607L392.734 445.61L392.731 446.633L391.644 446.63Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.542 446.635L393.545 445.612L394.631 445.616L394.628 446.639L393.542 446.635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.439 446.641L395.442 445.618L396.529 445.621L396.525 446.644L395.439 446.641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.336 446.647L397.339 445.624L398.426 445.627L398.423 446.65L397.336 446.647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.233 446.652L399.236 445.629L400.323 445.632L400.32 446.655L399.233 446.652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.131 446.658L401.134 445.635L402.22 445.638L402.217 446.661L401.131 446.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.028 446.663L403.031 445.64L404.118 445.644L404.115 446.667L403.028 446.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.925 446.669L404.928 445.646L406.015 445.649L406.012 446.672L404.925 446.669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.822 446.675L406.826 445.652L407.912 445.655L407.909 446.678L406.822 446.675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.72 446.68L408.723 445.657L409.809 445.66L409.806 446.683L408.72 446.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.617 446.686L410.62 445.663L411.707 445.666L411.704 446.689L410.617 446.686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.514 446.691L412.517 445.668L413.604 445.672L413.601 446.695L412.514 446.691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.412 446.697L414.415 445.674L415.501 445.677L415.498 446.7L414.412 446.697Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.309 446.703L416.312 445.68L417.398 445.683L417.395 446.706L416.309 446.703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.276 448.408L379.279 447.327L380.427 447.331L380.424 448.412L379.276 448.408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.173 448.414L381.176 447.333L382.325 447.336L382.321 448.417L381.173 448.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.07 448.419L383.074 447.339L384.222 447.342L384.219 448.423L383.07 448.419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.968 448.425L384.971 447.344L386.119 447.348L386.116 448.428L384.968 448.425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.865 448.431L386.868 447.35L388.016 447.353L388.013 448.434L386.865 448.431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.762 448.436L388.765 447.355L389.914 447.359L389.91 448.44L388.762 448.436Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.66 448.442L390.663 447.361L391.811 447.364L391.808 448.445L390.66 448.442Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.557 448.447L392.56 447.367L393.708 447.37L393.705 448.451L392.557 448.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.454 448.453L394.457 447.372L395.605 447.376L395.602 448.456L394.454 448.453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.351 448.459L396.355 447.378L397.503 447.381L397.5 448.462L396.351 448.459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.249 448.464L398.252 447.383L399.4 447.387L399.397 448.468L398.249 448.464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.146 448.47L400.149 447.389L401.297 447.392L401.294 448.473L400.146 448.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.043 448.476L402.046 447.395L403.195 447.398L403.191 448.479L402.043 448.476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.94 448.481L403.944 447.4L405.092 447.404L405.089 448.484L403.94 448.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.838 448.487L405.841 447.406L406.989 447.409L406.986 448.49L405.838 448.487Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.735 448.492L407.738 447.411L408.886 447.415L408.883 448.496L407.735 448.492Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.632 448.498L409.635 447.417L410.784 447.42L410.78 448.501L409.632 448.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.53 448.504L411.533 447.423L412.681 447.426L412.678 448.507L411.53 448.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.427 448.509L413.43 447.428L414.578 447.432L414.575 448.513L413.427 448.509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.324 448.515L415.327 447.434L416.475 447.437L416.472 448.518L415.324 448.515Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.19 450.224L380.194 449.089L381.4 449.092L381.396 450.228L380.19 450.224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.088 450.23L382.091 449.094L383.297 449.098L383.294 450.234L382.088 450.23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.985 450.236L383.988 449.1L385.194 449.104L385.191 450.239L383.985 450.236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.882 450.241L385.885 449.106L387.092 449.109L387.088 450.245L385.882 450.241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.779 450.247L387.783 449.111L388.989 449.115L388.985 450.25L387.779 450.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.677 450.252L389.68 449.117L390.886 449.12L390.883 450.256L389.677 450.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.574 450.258L391.577 449.123L392.783 449.126L392.78 450.262L391.574 450.258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.471 450.264L393.474 449.128L394.681 449.132L394.677 450.267L393.471 450.264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.368 450.269L395.372 449.134L396.578 449.137L396.575 450.273L395.368 450.269Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.266 450.275L397.269 449.139L398.475 449.143L398.472 450.278L397.266 450.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.163 450.28L399.166 449.145L400.372 449.148L400.369 450.284L399.163 450.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.06 450.286L401.064 449.151L402.27 449.154L402.266 450.29L401.06 450.286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.957 450.292L402.961 449.156L404.167 449.16L404.164 450.295L402.957 450.292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.855 450.297L404.858 449.162L406.064 449.165L406.061 450.301L404.855 450.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.752 450.303L406.755 449.167L407.961 449.171L407.958 450.306L406.752 450.303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.649 450.308L408.653 449.173L409.859 449.176L409.855 450.312L408.649 450.308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.547 450.314L410.55 449.179L411.756 449.182L411.753 450.318L410.547 450.314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.444 450.32L412.447 449.184L413.653 449.188L413.65 450.323L412.444 450.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.341 450.325L414.344 449.19L415.551 449.193L415.547 450.329L414.341 450.325Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.205 452.037L379.209 450.843L380.477 450.847L380.473 452.04L379.205 452.037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.103 452.042L381.106 450.849L382.374 450.852L382.37 452.046L381.103 452.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383 452.048L383.004 450.854L384.271 450.858L384.268 452.051L383 452.048Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.897 452.053L384.901 450.86L386.169 450.864L386.165 452.057L384.897 452.053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.795 452.059L386.798 450.866L388.066 450.869L388.062 452.063L386.795 452.059Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.692 452.065L388.695 450.871L389.963 450.875L389.96 452.068L388.692 452.065Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.589 452.07L390.593 450.877L391.86 450.88L391.857 452.074L390.589 452.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.486 452.076L392.49 450.882L393.758 450.886L393.754 452.079L392.486 452.076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.384 452.081L394.387 450.888L395.655 450.892L395.651 452.085L394.384 452.081Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.281 452.087L396.284 450.894L397.552 450.897L397.549 452.091L396.281 452.087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.178 452.093L398.182 450.899L399.449 450.903L399.446 452.096L398.178 452.093Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.075 452.098L400.079 450.905L401.347 450.908L401.343 452.102L400.075 452.098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.973 452.104L401.976 450.91L403.244 450.914L403.24 452.108L401.973 452.104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.87 452.109L403.873 450.916L405.141 450.92L405.138 452.113L403.87 452.109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.767 452.115L405.771 450.922L407.038 450.925L407.035 452.119L405.767 452.115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.664 452.121L407.668 450.927L408.936 450.931L408.932 452.124L407.664 452.121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.562 452.126L409.565 450.933L410.833 450.936L410.829 452.13L409.562 452.126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.459 452.132L411.463 450.938L412.73 450.942L412.727 452.136L411.459 452.132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.356 452.137L413.36 450.944L414.628 450.948L414.624 452.141L413.356 452.137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.118 453.854L380.122 452.603L381.451 452.607L381.447 453.858L380.118 453.854Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.015 453.86L382.019 452.609L383.348 452.612L383.345 453.864L382.015 453.86Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.912 453.866L383.916 452.614L385.245 452.618L385.242 453.869L383.912 453.866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.81 453.871L385.813 452.62L387.143 452.624L387.139 453.875L385.81 453.871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.707 453.877L387.711 452.625L389.04 452.629L389.036 453.881L387.707 453.877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.604 453.882L389.608 452.631L390.937 452.635L390.934 453.886L389.604 453.882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.502 453.888L391.505 452.637L392.835 452.64L392.831 453.892L391.502 453.888Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.399 453.894L393.403 452.642L394.732 452.646L394.728 453.897L393.399 453.894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.296 453.899L395.3 452.648L396.629 452.652L396.625 453.903L395.296 453.899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.193 453.905L397.197 452.653L398.526 452.657L398.523 453.909L397.193 453.905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.091 453.91L399.094 452.659L400.424 452.663L400.42 453.914L399.091 453.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.988 453.916L400.992 452.665L402.321 452.668L402.317 453.92L400.988 453.916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.885 453.922L402.889 452.67L404.218 452.674L404.214 453.925L402.885 453.922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.782 453.927L404.786 452.676L406.115 452.68L406.112 453.931L404.782 453.927Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.68 453.933L406.683 452.681L408.013 452.685L408.009 453.937L406.68 453.933Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.577 453.938L408.581 452.687L409.91 452.691L409.906 453.942L408.577 453.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.474 453.944L410.478 452.693L411.807 452.696L411.804 453.948L410.474 453.944Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.372 453.95L412.375 452.698L413.704 452.702L413.701 453.953L412.372 453.95Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.269 453.955L414.272 452.704L415.602 452.708L415.598 453.959L414.269 453.955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.135 455.665L379.139 454.359L380.526 454.363L380.522 455.669L379.135 455.665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.032 455.67L381.036 454.364L382.423 454.369L382.42 455.674L381.032 455.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.93 455.676L382.933 454.37L384.321 454.374L384.317 455.68L382.93 455.676Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.827 455.682L384.831 454.376L386.218 454.38L386.214 455.686L384.827 455.682Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.724 455.687L386.728 454.381L388.115 454.385L388.111 455.691L386.724 455.687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.621 455.693L388.625 454.387L390.012 454.391L390.009 455.697L388.621 455.693Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.519 455.698L390.522 454.392L391.91 454.397L391.906 455.703L390.519 455.698Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.416 455.704L392.42 454.398L393.807 454.402L393.803 455.708L392.416 455.704Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.313 455.71L394.317 454.404L395.704 454.408L395.7 455.714L394.313 455.71Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.21 455.715L396.214 454.409L397.602 454.413L397.598 455.719L396.21 455.715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.108 455.721L398.112 454.415L399.499 454.419L399.495 455.725L398.108 455.721Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.005 455.726L400.009 454.42L401.396 454.425L401.392 455.731L400.005 455.726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.902 455.732L401.906 454.426L403.293 454.43L403.289 455.736L401.902 455.732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.799 455.738L403.803 454.432L405.191 454.436L405.187 455.742L403.799 455.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.697 455.743L405.701 454.437L407.088 454.441L407.084 455.747L405.697 455.743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.594 455.749L407.598 454.443L408.985 454.447L408.981 455.753L407.594 455.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.491 455.754L409.495 454.448L410.882 454.453L410.879 455.759L409.491 455.754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.389 455.76L411.392 454.454L412.78 454.458L412.776 455.764L411.389 455.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.286 455.766L413.29 454.46L414.677 454.464L414.673 455.77L413.286 455.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.183 455.771L415.187 454.465L416.574 454.469L416.57 455.775L415.183 455.771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.047 457.483L380.052 456.119L381.5 456.123L381.496 457.487L380.047 457.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.945 457.488L381.949 456.124L383.398 456.129L383.394 457.492L381.945 457.488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.842 457.494L383.846 456.13L385.295 456.134L385.291 457.498L383.842 457.494Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.739 457.499L385.743 456.135L387.192 456.14L387.188 457.504L385.739 457.499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.637 457.505L387.641 456.141L389.089 456.145L389.085 457.509L387.637 457.505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.534 457.511L389.538 456.147L390.987 456.151L390.983 457.515L389.534 457.511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.431 457.516L391.435 456.152L392.884 456.157L392.88 457.52L391.431 457.516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.328 457.522L393.332 456.158L394.781 456.162L394.777 457.526L393.328 457.522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.226 457.527L395.23 456.163L396.678 456.168L396.674 457.532L395.226 457.527Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.123 457.533L397.127 456.169L398.576 456.173L398.572 457.537L397.123 457.533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.02 457.539L399.024 456.175L400.473 456.179L400.469 457.543L399.02 457.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.917 457.544L400.921 456.18L402.37 456.185L402.366 457.548L400.917 457.544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.815 457.55L402.819 456.186L404.268 456.19L404.264 457.554L402.815 457.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.712 457.555L404.716 456.191L406.165 456.196L406.161 457.56L404.712 457.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.609 457.561L406.613 456.197L408.062 456.201L408.058 457.565L406.609 457.561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.506 457.567L408.511 456.203L409.959 456.207L409.955 457.571L408.506 457.567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.404 457.572L410.408 456.208L411.857 456.213L411.853 457.577L410.404 457.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.301 457.578L412.305 456.214L413.754 456.218L413.75 457.582L412.301 457.578Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.198 457.583L414.202 456.22L415.651 456.224L415.647 457.588L414.198 457.583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.606 421.088L345.607 420.859L345.849 420.86L345.849 421.089L345.606 421.088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.503 421.094L347.504 420.865L347.747 420.866L347.746 421.094L347.503 421.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.401 421.099L349.401 420.871L349.644 420.871L349.643 421.1L349.401 421.099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.298 421.105L351.298 420.876L351.541 420.877L351.54 421.105L351.298 421.105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.195 421.11L353.196 420.882L353.438 420.883L353.438 421.111L353.195 421.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.092 421.116L355.093 420.887L355.336 420.888L355.335 421.117L355.092 421.116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.99 421.122L356.99 420.893L357.233 420.894L357.232 421.122L356.99 421.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.887 421.127L358.888 420.899L359.13 420.899L359.13 421.128L358.887 421.127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.784 421.133L360.785 420.904L361.027 420.905L361.027 421.133L360.784 421.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.681 421.138L362.682 420.91L362.925 420.911L362.924 421.139L362.681 421.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.579 421.144L364.579 420.915L364.822 420.916L364.821 421.145L364.579 421.144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.476 421.15L366.477 420.921L366.719 420.922L366.719 421.15L366.476 421.15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.373 421.155L368.374 420.927L368.617 420.927L368.616 421.156L368.373 421.155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.27 421.161L370.271 420.932L370.514 420.933L370.513 421.161L370.27 421.161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.168 421.166L372.168 420.938L372.411 420.939L372.41 421.167L372.168 421.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.065 421.172L374.066 420.943L374.308 420.944L374.308 421.173L374.065 421.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.962 421.178L375.963 420.949L376.206 420.95L376.205 421.178L375.962 421.178Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.86 421.183L377.86 420.955L378.103 420.955L378.102 421.184L377.86 421.183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.757 421.189L379.757 420.96L380 420.961L379.999 421.189L379.757 421.189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.623 422.898L344.624 422.615L344.924 422.616L344.924 422.899L344.623 422.898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.52 422.904L346.521 422.621L346.822 422.622L346.821 422.905L346.52 422.904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.418 422.91L348.418 422.627L348.719 422.627L348.718 422.91L348.418 422.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.315 422.915L350.316 422.632L350.616 422.633L350.615 422.916L350.315 422.915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.212 422.921L352.213 422.638L352.514 422.639L352.513 422.922L352.212 422.921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.109 422.926L354.11 422.643L354.411 422.644L354.41 422.927L354.109 422.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.007 422.932L356.007 422.649L356.308 422.65L356.307 422.933L356.007 422.932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.904 422.938L357.905 422.655L358.205 422.655L358.205 422.938L357.904 422.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.801 422.943L359.802 422.66L360.103 422.661L360.102 422.944L359.801 422.943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.698 422.949L361.699 422.666L362 422.667L361.999 422.95L361.698 422.949Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.596 422.954L363.597 422.671L363.897 422.672L363.896 422.955L363.596 422.954Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.493 422.96L365.494 422.677L365.794 422.678L365.794 422.961L365.493 422.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.39 422.966L367.391 422.683L367.692 422.683L367.691 422.967L367.39 422.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.287 422.971L369.288 422.688L369.589 422.689L369.588 422.972L369.287 422.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.185 422.977L371.186 422.694L371.486 422.695L371.485 422.978L371.185 422.977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.082 422.982L373.083 422.699L373.383 422.7L373.383 422.983L373.082 422.982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.979 422.988L374.98 422.705L375.281 422.706L375.28 422.989L374.979 422.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.877 422.994L376.877 422.711L377.178 422.712L377.177 422.995L376.877 422.994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.774 422.999L378.775 422.716L379.075 422.717L379.074 423L378.774 422.999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.638 424.711L343.639 424.37L344.001 424.371L344 424.712L343.638 424.711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.535 424.716L345.537 424.375L345.899 424.376L345.898 424.717L345.535 424.716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.433 424.722L347.434 424.381L347.796 424.382L347.795 424.723L347.433 424.722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.33 424.727L349.331 424.386L349.693 424.387L349.692 424.728L349.33 424.727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.227 424.733L351.228 424.392L351.591 424.393L351.59 424.734L351.227 424.733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.125 424.739L353.126 424.398L353.488 424.399L353.487 424.74L353.125 424.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.022 424.744L355.023 424.403L355.385 424.404L355.384 424.745L355.022 424.744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.919 424.75L356.92 424.409L357.282 424.41L357.281 424.751L356.919 424.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.816 424.755L358.817 424.414L359.18 424.415L359.179 424.756L358.816 424.755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.714 424.761L360.715 424.42L361.077 424.421L361.076 424.762L360.714 424.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.611 424.767L362.612 424.426L362.974 424.427L362.973 424.768L362.611 424.767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.508 424.772L364.509 424.431L364.871 424.432L364.87 424.773L364.508 424.772Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.405 424.778L366.406 424.437L366.769 424.438L366.768 424.779L366.405 424.778Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.303 424.783L368.304 424.442L368.666 424.443L368.665 424.784L368.303 424.783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.2 424.789L370.201 424.448L370.563 424.449L370.562 424.79L370.2 424.789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.097 424.795L372.098 424.454L372.46 424.455L372.459 424.796L372.097 424.795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.995 424.8L373.996 424.459L374.358 424.46L374.357 424.801L373.995 424.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.892 424.806L375.893 424.465L376.255 424.466L376.254 424.807L375.892 424.806Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.789 424.811L377.79 424.47L378.152 424.472L378.151 424.812L377.789 424.811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.686 424.817L379.687 424.476L380.05 424.477L380.049 424.818L379.686 424.817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.653 426.523L342.655 426.124L343.078 426.125L343.077 426.524L342.653 426.523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.551 426.528L344.552 426.129L344.976 426.131L344.974 426.53L344.551 426.528Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.448 426.534L346.449 426.135L346.873 426.136L346.872 426.535L346.448 426.534Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.345 426.54L348.346 426.141L348.77 426.142L348.769 426.541L348.345 426.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.243 426.545L350.244 426.146L350.667 426.147L350.666 426.546L350.243 426.545Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.14 426.551L352.141 426.152L352.565 426.153L352.564 426.552L352.14 426.551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.037 426.556L354.038 426.157L354.462 426.159L354.461 426.558L354.037 426.556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.934 426.562L355.936 426.163L356.359 426.164L356.358 426.563L355.934 426.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.832 426.568L357.833 426.169L358.257 426.17L358.255 426.569L357.832 426.568Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.729 426.573L359.73 426.174L360.154 426.175L360.153 426.574L359.729 426.573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.626 426.579L361.627 426.18L362.051 426.181L362.05 426.58L361.626 426.579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.523 426.584L363.525 426.185L363.948 426.187L363.947 426.586L363.523 426.584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.421 426.59L365.422 426.191L365.846 426.192L365.844 426.591L365.421 426.59Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.318 426.596L367.319 426.197L367.743 426.198L367.742 426.597L367.318 426.596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.215 426.601L369.216 426.202L369.64 426.203L369.639 426.602L369.215 426.601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.112 426.607L371.114 426.208L371.537 426.209L371.536 426.608L371.112 426.607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.01 426.612L373.011 426.213L373.435 426.215L373.434 426.614L373.01 426.612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.907 426.618L374.908 426.219L375.332 426.22L375.331 426.619L374.907 426.618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.804 426.624L376.805 426.225L377.229 426.226L377.228 426.625L376.804 426.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.702 426.629L378.703 426.23L379.126 426.232L379.125 426.63L378.702 426.629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.67 428.333L341.672 427.88L342.154 427.881L342.152 428.335L341.67 428.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.568 428.339L343.569 427.885L344.051 427.887L344.049 428.34L343.568 428.339Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.465 428.344L345.466 427.891L345.948 427.892L345.947 428.346L345.465 428.344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.362 428.35L347.364 427.897L347.845 427.898L347.844 428.351L347.362 428.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.26 428.356L349.261 427.902L349.743 427.904L349.741 428.357L349.26 428.356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.157 428.361L351.158 427.908L351.64 427.909L351.639 428.363L351.157 428.361Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.054 428.367L353.055 427.913L353.537 427.915L353.536 428.368L353.054 428.367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.951 428.372L354.953 427.919L355.434 427.92L355.433 428.374L354.951 428.372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.849 428.378L356.85 427.925L357.332 427.926L357.33 428.379L356.849 428.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.746 428.384L358.747 427.93L359.229 427.932L359.228 428.385L358.746 428.384Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.643 428.389L360.644 427.936L361.126 427.937L361.125 428.391L360.643 428.389Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.54 428.395L362.542 427.941L363.024 427.943L363.022 428.396L362.54 428.395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.438 428.4L364.439 427.947L364.921 427.948L364.919 428.402L364.438 428.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.335 428.406L366.336 427.953L366.818 427.954L366.817 428.407L366.335 428.406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.232 428.412L368.234 427.958L368.715 427.96L368.714 428.413L368.232 428.412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.129 428.417L370.131 427.964L370.613 427.965L370.611 428.419L370.129 428.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.027 428.423L372.028 427.969L372.51 427.971L372.508 428.424L372.027 428.423Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.924 428.428L373.925 427.975L374.407 427.976L374.406 428.43L373.924 428.428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.821 428.434L375.823 427.981L376.304 427.982L376.303 428.436L375.821 428.434Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.719 428.44L377.72 427.986L378.202 427.988L378.2 428.441L377.719 428.44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.616 428.445L379.617 427.992L380.099 427.993L380.098 428.447L379.616 428.445Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.686 430.145L340.687 429.634L341.231 429.636L341.229 430.147L340.686 430.145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.583 430.151L342.584 429.64L343.128 429.641L343.126 430.153L342.583 430.151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.48 430.157L344.482 429.645L345.025 429.647L345.024 430.158L344.48 430.157Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.378 430.162L346.379 429.651L346.922 429.652L346.921 430.164L346.378 430.162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.275 430.168L348.276 429.656L348.82 429.658L348.818 430.169L348.275 430.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.172 430.173L350.174 429.662L350.717 429.664L350.715 430.175L350.172 430.173Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.069 430.179L352.071 429.668L352.614 429.669L352.613 430.181L352.069 430.179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.967 430.185L353.968 429.673L354.511 429.675L354.51 430.186L353.967 430.185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.864 430.19L355.865 429.679L356.409 429.68L356.407 430.192L355.864 430.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.761 430.196L357.763 429.684L358.306 429.686L358.304 430.197L357.761 430.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.658 430.201L359.66 429.69L360.203 429.692L360.202 430.203L359.658 430.201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.556 430.207L361.557 429.696L362.1 429.697L362.099 430.209L361.556 430.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.453 430.213L363.454 429.701L363.998 429.703L363.996 430.214L363.453 430.213Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.35 430.218L365.352 429.707L365.895 429.708L365.893 430.22L365.35 430.218Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.247 430.224L367.249 429.712L367.792 429.714L367.791 430.225L367.247 430.224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.145 430.229L369.146 429.718L369.69 429.72L369.688 430.231L369.145 430.229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.042 430.235L371.043 429.724L371.587 429.725L371.585 430.237L371.042 430.235Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.939 430.241L372.941 429.729L373.484 429.731L373.483 430.242L372.939 430.241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.837 430.246L374.838 429.735L375.381 429.736L375.38 430.248L374.837 430.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.734 430.252L376.735 429.74L377.279 429.742L377.277 430.253L376.734 430.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.631 430.257L378.633 429.746L379.176 429.748L379.174 430.259L378.631 430.257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.598 431.963L341.6 431.394L342.205 431.396L342.203 431.965L341.598 431.963Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.495 431.969L343.497 431.399L344.102 431.401L344.1 431.971L343.495 431.969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.393 431.974L345.394 431.405L345.999 431.407L345.998 431.976L345.393 431.974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.29 431.98L347.292 431.411L347.897 431.412L347.895 431.982L347.29 431.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.187 431.986L349.189 431.416L349.794 431.418L349.792 431.987L349.187 431.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.085 431.991L351.086 431.422L351.691 431.424L351.689 431.993L351.085 431.991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.982 431.997L352.983 431.427L353.588 431.429L353.587 431.999L352.982 431.997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.879 432.002L354.881 431.433L355.486 431.435L355.484 432.004L354.879 432.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.776 432.008L356.778 431.439L357.383 431.44L357.381 432.01L356.776 432.008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.674 432.014L358.675 431.444L359.28 431.446L359.278 432.015L358.674 432.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.571 432.019L360.573 431.45L361.177 431.452L361.176 432.021L360.571 432.019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.468 432.025L362.47 431.455L363.075 431.457L363.073 432.027L362.468 432.025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.365 432.03L364.367 431.461L364.972 431.463L364.97 432.032L364.365 432.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.263 432.036L366.264 431.467L366.869 431.468L366.868 432.038L366.263 432.036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.16 432.042L368.162 431.472L368.766 431.474L368.765 432.043L368.16 432.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.057 432.047L370.059 431.478L370.664 431.48L370.662 432.049L370.057 432.047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.954 432.053L371.956 431.483L372.561 431.485L372.559 432.055L371.954 432.053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.852 432.058L373.853 431.489L374.458 431.491L374.457 432.06L373.852 432.058Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.749 432.064L375.751 431.495L376.356 431.496L376.354 432.066L375.749 432.064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.646 432.07L377.648 431.5L378.253 431.502L378.251 432.071L377.646 432.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.544 432.075L379.545 431.506L380.15 431.508L380.148 432.077L379.544 432.075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.615 433.774L340.617 433.15L341.28 433.152L341.278 433.776L340.615 433.774Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.512 433.779L342.514 433.155L343.177 433.157L343.175 433.781L342.512 433.779Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41 433.785L344.412 433.161L345.074 433.163L345.073 433.787L344.41 433.785Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.307 433.79L346.309 433.166L346.972 433.168L346.97 433.792L346.307 433.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.204 433.796L348.206 433.172L348.869 433.174L348.867 433.798L348.204 433.796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.102 433.802L350.103 433.178L350.766 433.18L350.764 433.804L350.102 433.802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.999 433.807L352.001 433.183L352.664 433.185L352.662 433.809L351.999 433.807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.896 433.813L353.898 433.189L354.561 433.191L354.559 433.815L353.896 433.813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.793 433.818L355.795 433.194L356.458 433.196L356.456 433.82L355.793 433.818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.691 433.824L357.692 433.2L358.355 433.202L358.353 433.826L357.691 433.824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.588 433.83L359.59 433.206L360.253 433.208L360.251 433.832L359.588 433.83Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.485 433.835L361.487 433.211L362.15 433.213L362.148 433.837L361.485 433.835Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.382 433.841L363.384 433.217L364.047 433.219L364.045 433.843L363.382 433.841Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.28 433.847L365.282 433.223L365.944 433.224L365.943 433.848L365.28 433.847Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.177 433.852L367.179 433.228L367.842 433.23L367.84 433.854L367.177 433.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.074 433.858L369.076 433.234L369.739 433.236L369.737 433.86L369.074 433.858Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.972 433.863L370.973 433.239L371.636 433.241L371.634 433.865L370.972 433.863Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.869 433.869L372.871 433.245L373.533 433.247L373.532 433.871L372.869 433.869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.766 433.875L374.768 433.251L375.431 433.252L375.429 433.876L374.766 433.875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.663 433.88L376.665 433.256L377.328 433.258L377.326 433.882L376.663 433.88Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.561 433.886L378.562 433.262L379.225 433.264L379.223 433.888L378.561 433.886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.528 435.591L341.53 434.909L342.254 434.912L342.252 435.594L341.528 435.591Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.425 435.597L343.427 434.915L344.151 434.917L344.149 435.599L343.425 435.597Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.322 435.603L345.324 434.921L346.049 434.923L346.047 435.605L345.322 435.603Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.22 435.608L347.222 434.926L347.946 434.928L347.944 435.61L347.22 435.608Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.117 435.614L349.119 434.932L349.843 434.934L349.841 435.616L349.117 435.614Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.014 435.619L351.016 434.937L351.74 434.94L351.738 435.622L351.014 435.619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.911 435.625L352.913 434.943L353.638 434.945L353.636 435.627L352.911 435.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.809 435.631L354.811 434.949L355.535 434.951L355.533 435.633L354.809 435.631Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.706 435.636L356.708 434.954L357.432 434.956L357.43 435.638L356.706 435.636Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.603 435.642L358.605 434.96L359.33 434.962L359.328 435.644L358.603 435.642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.5 435.647L360.502 434.966L361.227 434.968L361.225 435.65L360.5 435.647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.398 435.653L362.4 434.971L363.124 434.973L363.122 435.655L362.398 435.653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.295 435.659L364.297 434.977L365.021 434.979L365.019 435.661L364.295 435.659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.192 435.664L366.194 434.982L366.919 434.984L366.917 435.666L366.192 435.664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.089 435.67L368.091 434.988L368.816 434.99L368.814 435.672L368.089 435.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.987 435.675L369.989 434.994L370.713 434.996L370.711 435.678L369.987 435.675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.884 435.681L371.886 434.999L372.61 435.001L372.608 435.683L371.884 435.681Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.781 435.687L373.783 435.005L374.508 435.007L374.506 435.689L373.781 435.687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.679 435.692L375.681 435.01L376.405 435.012L376.403 435.694L375.679 435.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.576 435.698L377.578 435.016L378.302 435.018L378.3 435.7L377.576 435.698Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.473 435.704L379.475 435.022L380.199 435.024L380.197 435.706L379.473 435.704Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.543 437.404L340.545 436.664L341.331 436.666L341.329 437.406L340.543 437.404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.44 437.409L342.442 436.669L343.228 436.672L343.226 437.412L342.44 437.409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.337 437.415L344.34 436.675L345.126 436.677L345.123 437.417L344.337 437.415Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.235 437.42L346.237 436.68L347.023 436.683L347.021 437.423L346.235 437.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.132 437.426L348.134 436.686L348.92 436.688L348.918 437.428L348.132 437.426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.029 437.432L350.031 436.692L350.817 436.694L350.815 437.434L350.029 437.432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.927 437.437L351.929 436.697L352.715 436.7L352.713 437.44L351.927 437.437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.824 437.443L353.826 436.703L354.612 436.705L354.61 437.445L353.824 437.443Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.721 437.448L355.723 436.709L356.509 436.711L356.507 437.451L355.721 437.448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.618 437.454L357.621 436.714L358.407 436.716L358.404 437.456L357.618 437.454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.516 437.46L359.518 436.72L360.304 436.722L360.302 437.462L359.516 437.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.413 437.465L361.415 436.725L362.201 436.728L362.199 437.468L361.413 437.465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.31 437.471L363.312 436.731L364.098 436.733L364.096 437.473L363.31 437.471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.207 437.476L365.21 436.737L365.996 436.739L365.993 437.479L365.207 437.476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.105 437.482L367.107 436.742L367.893 436.744L367.891 437.484L367.105 437.482Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.002 437.488L369.004 436.748L369.79 436.75L369.788 437.49L369.002 437.488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.899 437.493L370.901 436.753L371.687 436.756L371.685 437.496L370.899 437.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.796 437.499L372.799 436.759L373.585 436.761L373.582 437.501L372.796 437.499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.694 437.504L374.696 436.765L375.482 436.767L375.48 437.507L374.694 437.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.591 437.51L376.593 436.77L377.379 436.772L377.377 437.512L376.591 437.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.488 437.516L378.49 436.776L379.276 436.778L379.274 437.518L378.488 437.516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.457 439.22L341.46 438.425L342.304 438.428L342.301 439.222L341.457 439.22Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.354 439.225L343.357 438.431L344.201 438.433L344.198 439.228L343.354 439.225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.252 439.231L345.254 438.436L346.098 438.439L346.096 439.233L345.252 439.231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.149 439.237L347.151 438.442L347.995 438.445L347.993 439.239L347.149 439.237Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.046 439.242L349.049 438.448L349.893 438.45L349.89 439.245L349.046 439.242Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.944 439.248L350.946 438.453L351.79 438.456L351.788 439.25L350.944 439.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.841 439.253L352.843 438.459L353.687 438.461L353.685 439.256L352.841 439.253Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.738 439.259L354.74 438.464L355.584 438.467L355.582 439.261L354.738 439.259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.635 439.265L356.638 438.47L357.482 438.473L357.479 439.267L356.635 439.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.533 439.27L358.535 438.476L359.379 438.478L359.377 439.273L358.533 439.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.43 439.276L360.432 438.481L361.276 438.484L361.274 439.278L360.43 439.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.327 439.281L362.33 438.487L363.173 438.489L363.171 439.284L362.327 439.281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.224 439.287L364.227 438.492L365.071 438.495L365.068 439.289L364.224 439.287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.122 439.293L366.124 438.498L366.968 438.501L366.966 439.295L366.122 439.293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.019 439.298L368.021 438.504L368.865 438.506L368.863 439.301L368.019 439.298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.916 439.304L369.919 438.509L370.763 438.512L370.76 439.306L369.916 439.304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.814 439.309L371.816 438.515L372.66 438.517L372.657 439.312L371.814 439.309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.711 439.315L373.713 438.52L374.557 438.523L374.555 439.317L373.711 439.315Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.608 439.321L375.61 438.526L376.454 438.529L376.452 439.323L375.608 439.321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.505 439.326L377.508 438.532L378.352 438.534L378.349 439.329L377.505 439.326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.403 439.332L379.405 438.537L380.249 438.54L380.247 439.334L379.403 439.332Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.472 441.032L340.475 440.179L341.38 440.182L341.378 441.035L340.472 441.032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.37 441.037L342.372 440.185L343.278 440.188L343.275 441.04L342.37 441.037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.267 441.043L344.269 440.191L345.175 440.193L345.172 441.046L344.267 441.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.164 441.049L346.167 440.196L347.072 440.199L347.07 441.051L346.164 441.049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.062 441.054L348.064 440.202L348.97 440.205L348.967 441.057L348.062 441.054Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.959 441.06L349.961 440.207L350.867 440.21L350.864 441.063L349.959 441.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.856 441.065L351.859 440.213L352.764 440.216L352.762 441.068L351.856 441.065Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.753 441.071L353.756 440.219L354.661 440.221L354.659 441.074L353.753 441.071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.651 441.077L355.653 440.224L356.559 440.227L356.556 441.079L355.651 441.077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.548 441.082L357.55 440.23L358.456 440.233L358.453 441.085L357.548 441.082Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.445 441.088L359.448 440.235L360.353 440.238L360.351 441.091L359.445 441.088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.342 441.094L361.345 440.241L362.25 440.244L362.248 441.096L361.342 441.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.24 441.099L363.242 440.247L364.148 440.249L364.145 441.102L363.24 441.099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.137 441.105L365.139 440.252L366.045 440.255L366.042 441.107L365.137 441.105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.034 441.11L367.037 440.258L367.942 440.261L367.94 441.113L367.034 441.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.931 441.116L368.934 440.263L369.839 440.266L369.837 441.119L368.931 441.116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.829 441.122L370.831 440.269L371.737 440.272L371.734 441.124L370.829 441.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.726 441.127L372.729 440.275L373.634 440.277L373.632 441.13L372.726 441.127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.623 441.133L374.626 440.28L375.531 440.283L375.529 441.135L374.623 441.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.521 441.138L376.523 440.286L377.429 440.289L377.426 441.141L376.521 441.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.418 441.144L378.42 440.291L379.326 440.294L379.323 441.147L378.418 441.144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.385 442.85L341.388 441.939L342.355 441.942L342.352 442.853L341.385 442.85Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.282 442.855L343.285 441.945L344.252 441.948L344.249 442.858L343.282 442.855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.179 442.861L345.182 441.95L346.149 441.953L346.147 442.864L345.179 442.861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.077 442.866L347.079 441.956L348.047 441.959L348.044 442.869L347.077 442.866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.974 442.872L348.977 441.962L349.944 441.965L349.941 442.875L348.974 442.872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.871 442.878L350.874 441.967L351.841 441.97L351.838 442.881L350.871 442.878Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.769 442.883L352.771 441.973L353.738 441.976L353.736 442.886L352.769 442.883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.666 442.889L354.668 441.978L355.636 441.981L355.633 442.892L354.666 442.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.563 442.894L356.566 441.984L357.533 441.987L357.53 442.897L356.563 442.894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.46 442.9L358.463 441.99L359.43 441.993L359.427 442.903L358.46 442.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.358 442.906L360.36 441.995L361.327 441.998L361.325 442.909L360.358 442.906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.255 442.911L362.258 442.001L363.225 442.004L363.222 442.914L362.255 442.911Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.152 442.917L364.155 442.006L365.122 442.009L365.119 442.92L364.152 442.917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.049 442.923L366.052 442.012L367.019 442.015L367.016 442.925L366.049 442.923Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.947 442.928L367.949 442.018L368.916 442.021L368.914 442.931L367.947 442.928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.844 442.934L369.847 442.023L370.814 442.026L370.811 442.937L369.844 442.934Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.741 442.939L371.744 442.029L372.711 442.032L372.708 442.942L371.741 442.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.638 442.945L373.641 442.035L374.608 442.037L374.606 442.948L373.638 442.945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.536 442.951L375.538 442.04L376.506 442.043L376.503 442.953L375.536 442.951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.433 442.956L377.436 442.046L378.403 442.049L378.4 442.959L377.433 442.956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.402 444.66L340.405 443.695L341.43 443.698L341.427 444.663L340.402 444.66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.299 444.666L342.302 443.701L343.327 443.704L343.324 444.669L342.299 444.666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.196 444.671L344.199 443.706L345.224 443.709L345.222 444.674L344.196 444.671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.094 444.677L346.097 443.712L347.122 443.715L347.119 444.68L346.094 444.677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.991 444.683L347.994 443.718L349.019 443.721L349.016 444.686L347.991 444.683Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.888 444.688L349.891 443.723L350.916 443.726L350.913 444.691L349.888 444.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.786 444.694L351.788 443.729L352.813 443.732L352.811 444.697L351.786 444.694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.683 444.699L353.686 443.734L354.711 443.737L354.708 444.702L353.683 444.699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.58 444.705L355.583 443.74L356.608 443.743L356.605 444.708L355.58 444.705Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.477 444.711L357.48 443.746L358.505 443.749L358.502 444.714L357.477 444.711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.375 444.716L359.377 443.751L360.403 443.754L360.4 444.719L359.375 444.716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.272 444.722L361.275 443.757L362.3 443.76L362.297 444.725L361.272 444.722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.169 444.727L363.172 443.762L364.197 443.765L364.194 444.73L363.169 444.727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.066 444.733L365.069 443.768L366.094 443.771L366.091 444.736L365.066 444.733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.964 444.739L366.967 443.774L367.992 443.777L367.989 444.742L366.964 444.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.861 444.744L368.864 443.779L369.889 443.782L369.886 444.747L368.861 444.744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.758 444.75L370.761 443.785L371.786 443.788L371.783 444.753L370.758 444.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.656 444.755L372.658 443.79L373.683 443.793L373.681 444.758L372.656 444.755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.553 444.761L374.556 443.796L375.581 443.799L375.578 444.764L374.553 444.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.45 444.767L376.453 443.802L377.478 443.805L377.475 444.77L376.45 444.767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.347 444.772L378.35 443.807L379.375 443.81L379.372 444.775L378.347 444.772Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.314 446.478L341.317 445.455L342.404 445.458L342.401 446.481L341.314 446.478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.212 446.484L343.215 445.461L344.301 445.464L344.298 446.487L343.212 446.484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.109 446.489L345.112 445.466L346.199 445.469L346.196 446.492L345.109 446.489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.006 446.495L347.009 445.472L348.096 445.475L348.093 446.498L347.006 446.495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.904 446.5L348.907 445.477L349.993 445.481L349.99 446.504L348.904 446.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.801 446.506L350.804 445.483L351.89 445.486L351.887 446.509L350.801 446.506Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.698 446.512L352.701 445.489L353.788 445.492L353.785 446.515L352.698 446.512Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.595 446.517L354.598 445.494L355.685 445.497L355.682 446.52L354.595 446.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.493 446.523L356.496 445.5L357.582 445.503L357.579 446.526L356.493 446.523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.39 446.528L358.393 445.505L359.479 445.509L359.476 446.532L358.39 446.528Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.287 446.534L360.29 445.511L361.377 445.514L361.374 446.537L360.287 446.534Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.184 446.54L362.187 445.517L363.274 445.52L363.271 446.543L362.184 446.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.082 446.545L364.085 445.522L365.171 445.525L365.168 446.548L364.082 446.545Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.979 446.551L365.982 445.528L367.069 445.531L367.066 446.554L365.979 446.551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.876 446.556L367.879 445.533L368.966 445.537L368.963 446.56L367.876 446.556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.773 446.562L369.776 445.539L370.863 445.542L370.86 446.565L369.773 446.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.671 446.568L371.674 445.545L372.76 445.548L372.757 446.571L371.671 446.568Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.568 446.573L373.571 445.55L374.658 445.553L374.655 446.576L373.568 446.573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.465 446.579L375.468 445.556L376.555 445.559L376.552 446.582L375.465 446.579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.363 446.584L377.366 445.561L378.452 445.565L378.449 446.588L377.363 446.584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.33 448.29L340.333 447.209L341.481 447.213L341.478 448.293L340.33 448.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.227 448.296L342.23 447.215L343.378 447.218L343.375 448.299L342.227 448.296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.124 448.301L344.127 447.22L345.276 447.224L345.272 448.305L344.124 448.301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.021 448.307L346.025 447.226L347.173 447.229L347.17 448.31L346.021 448.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.919 448.313L347.922 447.232L349.07 447.235L349.067 448.316L347.919 448.313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.816 448.318L349.819 447.237L350.967 447.241L350.964 448.322L349.816 448.318Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.713 448.324L351.716 447.243L352.865 447.246L352.861 448.327L351.713 448.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.611 448.329L353.614 447.248L354.762 447.252L354.759 448.333L353.611 448.329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.508 448.335L355.511 447.254L356.659 447.257L356.656 448.338L355.508 448.335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.405 448.341L357.408 447.26L358.556 447.263L358.553 448.344L357.405 448.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.302 448.346L359.306 447.265L360.454 447.269L360.451 448.35L359.302 448.346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.2 448.352L361.203 447.271L362.351 447.274L362.348 448.355L361.2 448.352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.097 448.357L363.1 447.276L364.248 447.28L364.245 448.361L363.097 448.357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.994 448.363L364.997 447.282L366.146 447.285L366.142 448.366L364.994 448.363Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.891 448.369L366.895 447.288L368.043 447.291L368.04 448.372L366.891 448.369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.789 448.374L368.792 447.293L369.94 447.297L369.937 448.378L368.789 448.374Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.686 448.38L370.689 447.299L371.837 447.302L371.834 448.383L370.686 448.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.583 448.385L372.586 447.304L373.735 447.308L373.731 448.389L372.583 448.385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.48 448.391L374.484 447.31L375.632 447.313L375.629 448.394L374.48 448.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.378 448.397L376.381 447.316L377.529 447.319L377.526 448.4L376.378 448.397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.244 450.106L341.247 448.971L342.453 448.974L342.45 450.11L341.244 450.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.141 450.112L343.145 448.976L344.351 448.98L344.347 450.115L343.141 450.112Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.039 450.117L345.042 448.982L346.248 448.985L346.245 450.121L345.039 450.117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.936 450.123L346.939 448.988L348.145 448.991L348.142 450.127L346.936 450.123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.833 450.129L348.836 448.993L350.043 448.997L350.039 450.132L348.833 450.129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73 450.134L350.734 448.999L351.94 449.002L351.936 450.138L350.73 450.134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.628 450.14L352.631 449.004L353.837 449.008L353.834 450.143L352.628 450.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.525 450.145L354.528 449.01L355.734 449.014L355.731 450.149L354.525 450.145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.422 450.151L356.425 449.016L357.632 449.019L357.628 450.155L356.422 450.151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.319 450.157L358.323 449.021L359.529 449.025L359.526 450.16L358.319 450.157Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.217 450.162L360.22 449.027L361.426 449.03L361.423 450.166L360.217 450.162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.114 450.168L362.117 449.032L363.323 449.036L363.32 450.171L362.114 450.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.011 450.173L364.015 449.038L365.221 449.042L365.217 450.177L364.011 450.173Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.908 450.179L365.912 449.044L367.118 449.047L367.115 450.183L365.908 450.179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.806 450.185L367.809 449.049L369.015 449.053L369.012 450.188L367.806 450.185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.703 450.19L369.706 449.055L370.912 449.058L370.909 450.194L369.703 450.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.6 450.196L371.604 449.06L372.81 449.064L372.806 450.199L371.6 450.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.498 450.201L373.501 449.066L374.707 449.07L374.704 450.205L373.498 450.201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.395 450.207L375.398 449.072L376.604 449.075L376.601 450.211L375.395 450.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.259 451.918L340.263 450.725L341.53 450.729L341.527 451.922L340.259 451.918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.156 451.924L342.16 450.731L343.428 450.734L343.424 451.928L342.156 451.924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.054 451.93L344.057 450.736L345.325 450.74L345.321 451.933L344.054 451.93Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.951 451.935L345.955 450.742L347.222 450.745L347.219 451.939L345.951 451.935Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.848 451.941L347.852 450.747L349.119 450.751L349.116 451.945L347.848 451.941Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.746 451.946L349.749 450.753L351.017 450.757L351.013 451.95L349.746 451.946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.643 451.952L351.646 450.759L352.914 450.762L352.911 451.956L351.643 451.952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54 451.958L353.544 450.764L354.811 450.768L354.808 451.961L353.54 451.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.437 451.963L355.441 450.77L356.709 450.773L356.705 451.967L355.437 451.963Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.335 451.969L357.338 450.775L358.606 450.779L358.602 451.973L357.335 451.969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.232 451.974L359.235 450.781L360.503 450.785L360.5 451.978L359.232 451.974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.129 451.98L361.133 450.787L362.4 450.79L362.397 451.984L361.129 451.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.026 451.986L363.03 450.792L364.298 450.796L364.294 451.989L363.026 451.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.924 451.991L364.927 450.798L366.195 450.802L366.191 451.995L364.924 451.991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.821 451.997L366.824 450.803L368.092 450.807L368.089 452.001L366.821 451.997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.718 452.002L368.722 450.809L369.989 450.813L369.986 452.006L368.718 452.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.615 452.008L370.619 450.815L371.887 450.818L371.883 452.012L370.615 452.008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.513 452.014L372.516 450.82L373.784 450.824L373.78 452.017L372.513 452.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.41 452.019L374.414 450.826L375.681 450.83L375.678 452.023L374.41 452.019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.172 453.736L341.175 452.485L342.505 452.489L342.501 453.74L341.172 453.736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.069 453.742L343.073 452.49L344.402 452.494L344.398 453.746L343.069 453.742Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.966 453.747L344.97 452.496L346.299 452.5L346.295 453.751L344.966 453.747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.863 453.753L346.867 452.502L348.196 452.505L348.193 453.757L346.863 453.753Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.761 453.759L348.764 452.507L350.094 452.511L350.09 453.762L348.761 453.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.658 453.764L350.662 452.513L351.991 452.517L351.987 453.768L350.658 453.764Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.555 453.77L352.559 452.518L353.888 452.522L353.885 453.774L352.555 453.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.453 453.775L354.456 452.524L355.786 452.528L355.782 453.779L354.453 453.775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.35 453.781L356.354 452.53L357.683 452.533L357.679 453.785L356.35 453.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.247 453.787L358.251 452.535L359.58 452.539L359.576 453.79L358.247 453.787Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.144 453.792L360.148 452.541L361.477 452.545L361.474 453.796L360.144 453.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.042 453.798L362.045 452.546L363.375 452.55L363.371 453.802L362.042 453.798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.939 453.803L363.943 452.552L365.272 452.556L365.268 453.807L363.939 453.803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.836 453.809L365.84 452.558L367.169 452.562L367.165 453.813L365.836 453.809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.733 453.815L367.737 452.563L369.066 452.567L369.063 453.819L367.733 453.815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.631 453.82L369.634 452.569L370.964 452.573L370.96 453.824L369.631 453.82Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.528 453.826L371.532 452.574L372.861 452.578L372.857 453.83L371.528 453.826Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.425 453.831L373.429 452.58L374.758 452.584L374.755 453.835L373.425 453.831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.322 453.837L375.326 452.586L376.655 452.59L376.652 453.841L375.322 453.837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.189 455.547L340.193 454.241L341.58 454.245L341.576 455.551L340.189 455.547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.086 455.552L342.09 454.246L343.477 454.25L343.473 455.556L342.086 455.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.983 455.558L343.987 454.252L345.374 454.256L345.37 455.562L343.983 455.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.881 455.563L345.884 454.257L347.272 454.262L347.268 455.568L345.881 455.563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.778 455.569L347.782 454.263L349.169 454.267L349.165 455.573L347.778 455.569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.675 455.575L349.679 454.269L351.066 454.273L351.062 455.579L349.675 455.575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.572 455.58L351.576 454.274L352.963 454.278L352.96 455.584L351.572 455.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.47 455.586L353.473 454.28L354.861 454.284L354.857 455.59L353.47 455.586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.367 455.591L355.371 454.285L356.758 454.29L356.754 455.596L355.367 455.591Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.264 455.597L357.268 454.291L358.655 454.295L358.651 455.601L357.264 455.597Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.161 455.603L359.165 454.297L360.552 454.301L360.549 455.607L359.161 455.603Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.059 455.608L361.063 454.302L362.45 454.306L362.446 455.612L361.059 455.608Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.956 455.614L362.96 454.308L364.347 454.312L364.343 455.618L362.956 455.614Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.853 455.619L364.857 454.314L366.244 454.318L366.24 455.624L364.853 455.619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.75 455.625L366.754 454.319L368.142 454.323L368.138 455.629L366.75 455.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.648 455.631L368.652 454.325L370.039 454.329L370.035 455.635L368.648 455.631Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.545 455.636L370.549 454.33L371.936 454.334L371.932 455.64L370.545 455.636Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.442 455.642L372.446 454.336L373.833 454.34L373.83 455.646L372.442 455.642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.34 455.647L374.343 454.342L375.731 454.346L375.727 455.652L374.34 455.647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.237 455.653L376.241 454.347L377.628 454.351L377.624 455.657L376.237 455.653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.101 457.364L341.105 456L342.554 456.005L342.55 457.369L341.101 457.364Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.998 457.37L343.002 456.006L344.451 456.01L344.447 457.374L342.998 457.37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.896 457.376L344.9 456.012L346.349 456.016L346.345 457.38L344.896 457.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.793 457.381L346.797 456.017L348.246 456.022L348.242 457.385L346.793 457.381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.69 457.387L348.694 456.023L350.143 456.027L350.139 457.391L348.69 457.387Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.588 457.392L350.592 456.028L352.04 456.033L352.036 457.397L350.588 457.392Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.485 457.398L352.489 456.034L353.938 456.038L353.934 457.402L352.485 457.398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.382 457.404L354.386 456.04L355.835 456.044L355.831 457.408L354.382 457.404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.279 457.409L356.283 456.045L357.732 456.05L357.728 457.414L356.279 457.409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.177 457.415L358.181 456.051L359.629 456.055L359.625 457.419L358.177 457.415Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.074 457.42L360.078 456.057L361.527 456.061L361.523 457.425L360.074 457.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.971 457.426L361.975 456.062L363.424 456.066L363.42 457.43L361.971 457.426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.868 457.432L363.872 456.068L365.321 456.072L365.317 457.436L363.868 457.432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.766 457.437L365.77 456.073L367.219 456.078L367.214 457.442L365.766 457.437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.663 457.443L367.667 456.079L369.116 456.083L369.112 457.447L367.663 457.443Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.56 457.448L369.564 456.085L371.013 456.089L371.009 457.453L369.56 457.448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.457 457.454L371.461 456.09L372.91 456.094L372.906 457.458L371.457 457.454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.355 457.46L373.359 456.096L374.808 456.1L374.804 457.464L373.355 457.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.252 457.465L375.256 456.101L376.705 456.106L376.701 457.47L375.252 457.465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_f_659_491)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.04902,
    cy: 3.46788,
    rx: 9.04902,
    ry: 3.46788,
    transform: "matrix(-1 0 0 1 414.078 371.384)",
    fill: "#ED1B2F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter3_f_659_491)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.04765,
    cy: 1.55119,
    rx: 4.04765,
    ry: 1.55119,
    transform: "matrix(-1 0 0 1 434.596 369.834)",
    fill: "#ED1B2F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M363.493 361.432C361.699 371.655 369.096 391.828 374.414 400.769L383.214 398.721C380.959 384.83 377.048 367.121 372.115 359.705C372.68 360.475 375.387 359.26 375.696 356.081C375.981 353.152 373.317 351.678 370.73 352.146C368.156 345.463 362.71 349.586 362.69 352.256C357.376 352.533 357.754 356.362 359.426 358.086C358.44 361.421 361.345 363.605 363.493 361.432Z",
    fill: "#FFA896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.414 400.769C369.096 391.828 361.699 371.655 363.493 361.432C361.345 363.605 358.44 361.421 359.426 358.086C357.754 356.362 357.376 352.533 362.69 352.256C362.71 349.586 368.156 345.463 370.73 352.146C373.317 351.678 375.981 353.152 375.696 356.081C375.387 359.26 372.68 360.475 372.115 359.705C377.048 367.121 380.959 384.83 383.214 398.721",
    stroke: "black",
    strokeWidth: 1.12159
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_659_491",
    x: 981.679,
    y: 369.141,
    width: 22.584,
    height: 11.4221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.12159,
    result: "effect1_foregroundBlur_659_491"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_659_491",
    x: 961.161,
    y: 367.591,
    width: 12.582,
    height: 7.58876,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.12159,
    result: "effect1_foregroundBlur_659_491"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_659_491",
    x: 393.737,
    y: 369.141,
    width: 22.584,
    height: 11.4221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.12159,
    result: "effect1_foregroundBlur_659_491"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_659_491",
    x: 424.257,
    y: 367.591,
    width: 12.582,
    height: 7.58876,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.12159,
    result: "effect1_foregroundBlur_659_491"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_659_491",
    x1: 1010.14,
    y1: 411.074,
    x2: 1039.28,
    y2: 507.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_659_491",
    x1: 387.861,
    y1: 411.074,
    x2: 358.717,
    y2: 507.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_659_491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 104,
    fill: "white",
    transform: "translate(913 326)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_659_491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 104,
    fill: "white",
    transform: "matrix(-1 0 0 1 485 326)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSuccess);
export default __webpack_public_path__ + "static/media/about-success.a6bdd6a083b746ebea167a42297fe81f.svg";
export { ForwardRef as ReactComponent };